(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6478],{

/***/ 51231:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculadora-desconto",
      function () {
        return __webpack_require__(42563);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96590);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Icon_IconArrowRight__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83319);








/**
 *
 * @param {arrowRight} boolean {arrowRight - true:false - exibir seta para ir para próxima página}
 * @returns
 */ function Button(props) {
    var ref, ref1, ref2, ref3;
    var className = props.className, isDisable = props.isDisable, arrowRight = props.arrowRight, handleOnClick = props.handleOnClick, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "className",
        "isDisable",
        "arrowRight",
        "handleOnClick"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            style: {
                color: props.isDisable ? "#7a7c7b" : props === null || props === void 0 ? void 0 : (ref = props.wl) === null || ref === void 0 ? void 0 : ref.cor_texto_botao,
                background: props.isDisable ? (ref1 = props.wl) === null || ref1 === void 0 ? void 0 : ref1.cor_tema_botao_desabilitado : ((ref2 = props.wl) === null || ref2 === void 0 ? void 0 : ref2.cor_tema_botao_solido) ? (ref3 = props.wl) === null || ref3 === void 0 ? void 0 : ref3.cor_tema_botao_solido : "1"
            },
            className: props.arrowRight ? "".concat((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().button), " ").concat((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().arrowRight), " ").concat(className) : "".concat((_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().button), " ").concat(className),
            onClick: handleOnClick,
            disabled: props.isDisable ? true : false
        }, restProps), {
            children: [
                props.name,
                props.arrowRight ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon_IconArrowRight__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    wl: props.wl
                }) : ""
            ]
        }))
    });
}


/***/ }),

/***/ 95416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52502);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);






/**
 *
 * @param {*} props [
 * 	stylesIcon = styles para aplicar na tag img dentro do button
 * 	srcIcon = url img do icon
 * 	svgTag = tag svg da imagem, inutiliza o srcIcon
 * 	iconPosition = left|right - relacionado ao children: antes ou depois : default right
 * ]
 * @returns
 */ var ButtonIcon = function(props) {
    var children = props.children, iconWidth = props.iconWidth, iconHeight = props.iconHeight, stylesIcon = props.stylesIcon, srcIcon = props.srcIcon, iconPosition = props.iconPosition, className = props.className, svgTag = props.svgTag, wl = props.wl, bgded = props.bgded, onFocus = props.onFocus, onBlur = props.onBlur, onMouseOver = props.onMouseOver, onMouseLeave = props.onMouseLeave, color = props.color, hoverColor = props.hoverColor, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "children",
        "iconWidth",
        "iconHeight",
        "stylesIcon",
        "srcIcon",
        "iconPosition",
        "className",
        "svgTag",
        "wl",
        "bgded",
        "onFocus",
        "onBlur",
        "onMouseOver",
        "onMouseLeave",
        "color",
        "hoverColor"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), styleFocus = ref[0], setStyleFocus = ref[1];
    var marginIcon = iconPosition == "left" ? {
        marginRight: "8px"
    } : {
        marginLeft: "8px"
    };
    var iconSetWidth = iconWidth ? iconWidth : "16px";
    var iconSetHeight = iconHeight ? iconHeight : "16px";
    var icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().img),
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            marginTop: "auto",
            marginBottom: "auto",
            maxHeight: "".concat(iconSetHeight, "!important"),
            maxWidth: "".concat(iconSetWidth, "!important")
        }, marginIcon),
        children: !!svgTag ? svgTag : srcIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            style: {
                maxHeight: "".concat(iconSetHeight, "!important"),
                maxWidth: "".concat(iconSetWidth, "!important"),
                stylesIcon: stylesIcon
            },
            src: srcIcon,
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().img),
            alt: ""
        }) : ""
    });
    var focus = function(event) {
        if (onFocus) {
            onFocus(event);
        }
        setStyleFocus({
            border: "1px ".concat(wl.cor_tema_4, " solid"),
            backgroundColor: wl.cor_tema_4,
            boxShadow: "0 0 0.5rem ".concat(wl.cor_tema_4),
            outline: 0
        });
    };
    var blur = function(event) {
        if (onBlur) {
            onBlur(event);
        }
        setStyleFocus({
            border: "1px ".concat(color ? color : wl === null || wl === void 0 ? void 0 : wl.cor_tema_secundaria, " solid")
        });
    };
    var hover = function(event) {
        if (onMouseOver) {
            onMouseOver(event);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().spanButton),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                border: (className === null || className === void 0 ? void 0 : className.includes("selected")) ? color ? color : wl === null || wl === void 0 ? void 0 : wl.cor_tema_secundaria : "1px ".concat(color ? color : wl === null || wl === void 0 ? void 0 : wl.cor_tema_secundaria, " solid"),
                color: "".concat(bgded ? wl.cor_texto_botao : color ? color : wl === null || wl === void 0 ? void 0 : wl.cor_tema_secundaria),
                backgroundColor: (className === null || className === void 0 ? void 0 : className.includes("selected")) ? wl === null || wl === void 0 ? void 0 : wl.cor_tema_4 : "".concat(bgded ? wl === null || wl === void 0 ? void 0 : wl.cor_tema_secundaria : "")
            }, styleFocus),
            onFocus: focus,
            onBlur: blur,
            onMouseOver: hover,
            // onMouseLeave={leave}
            className: "".concat((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().button), " ").concat(className)
        }, restProps), {
            children: [
                iconPosition == "left" ? icon : "",
                children,
                iconPosition != "left" ? icon : ""
            ]
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonIcon);


/***/ }),

/***/ 83319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconArrowRight; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function IconArrowRight(props) {
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "13",
        height: "14",
        viewBox: "0 0 13 14",
        fill: props === null || props === void 0 ? void 0 : (ref = props.wl) === null || ref === void 0 ? void 0 : ref.cor_texto_botao,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M0.5 7H12.5M12.5 7L6.5 1M12.5 7L6.5 13",
            stroke: props === null || props === void 0 ? void 0 : props.wl.cor_texto_botao,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}


/***/ }),

/***/ 41870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Select_Select2; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 10 modules
var react_select_esm = __webpack_require__(75217);
// EXTERNAL MODULE: ./src/components/Select/Select2/styles.module.css
var styles_module = __webpack_require__(14334);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(47041);
;// CONCATENATED MODULE: ./src/components/Select/Select2/src/find-options-effect.js


var useFindOptionsEffect = function(searchValue, handleFindOptions, setOptions, setLoading, nomeCampo) {
    (0,react.useEffect)(function() {
        if ((searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) > 2) {
            setLoading(true);
            var timer = setTimeout(function() {
                if (handleFindOptions) {
                    handleFindOptions(searchValue).then(function(resultOptions) {
                        (0,lib.setCookie)("electy-server@".concat(nomeCampo), resultOptions);
                        setOptions(resultOptions);
                    }).catch(function(err) {
                        setOptions([]);
                    }).finally(function() {
                        setLoading(false);
                    });
                }
            }, 1000);
            return function() {
                setLoading(false);
                clearTimeout(timer);
            };
        }
    }, [
        searchValue
    ]);
};

;// CONCATENATED MODULE: ./src/components/Select/Select2/index.jsx









var groupStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "#D9D9D980",
    color: "var(--black-400)",
    fontWeight: "bold",
    textTransform: "capitalize"
};
var formatGroupLabel = function(data) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: groupStyles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: data.label
        })
    });
};
/**
 * Componente que utiliza lib Select2
 * 
 * @param {onFocus} param0 
 * @returns 
 */ var Select2 = function(_param) {
    var onFocus = _param.onFocus, onBlur = _param.onBlur, handleChange = _param.handleChange, style = _param.style, handleFindOptions = _param.handleFindOptions, noOptionsMessage = _param.noOptionsMessage, className = _param.className, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "onFocus",
        "onBlur",
        "handleChange",
        "style",
        "handleFindOptions",
        "noOptionsMessage",
        "className"
    ]);
    var ref;
    var ref1 = (0,react.useState)({}), styleFocus = ref1[0], setStyleFocus = ref1[1];
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var _options;
    var ref3 = (0,react.useState)((_options = restProps.options) !== null && _options !== void 0 ? _options : []), options = ref3[0], setOptions = ref3[1];
    var ref4 = (0,react.useState)(""), searchValue = ref4[0], setSearchValue = ref4[1];
    useFindOptionsEffect(searchValue, handleFindOptions, setOptions, setLoading, restProps.name);
    var handleInputChange = function(inputValue, param) {
        var action = param.action;
        if (action === "input-change") {
            setSearchValue(inputValue);
        }
    };
    // const handleChangeOpcaoSelecionada   = (opcaoSelecionada) => {
    //   setValue(opcaoSelecionada?.label);
    //   handleChange(opcaoSelecionada);
    // }
    var customStyles = {
        control: function(base) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                height: 40
            });
        }
    };
    var focus = function(event) {
        if (onFocus) {
            onFocus(event);
        }
        setStyleFocus({
            border: "1px solid red !important",
            boxShadow: "0 0 0.5rem red !important",
            outline: 0
        });
    };
    var blur = function(event) {
        if (onBlur) {
            onBlur(event);
        }
        setStyleFocus({});
    };
    var customLoadingMessage = function() {
        return "Carregando...";
    };
    // Função para personalizar a mensagem quando não há opções
    var handleNoOptionsMessage = function(param) {
        var inputValue = param.inputValue;
        return inputValue ? noOptionsMessage : "Digite para buscar op\xe7\xf5es";
    };
    var _required, _isClearable, _isSearchable, _isDisabled, _isLoading, _isRtl, _name, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
            id: restProps.id,
            styles: (0,_object_spread/* default */.Z)({}, customStyles, styleFocus, style),
            className: "".concat((styles_module_default()).select, " ").concat(className),
            options: options,
            onFocus: focus,
            onBlur: blur,
            required: (_required = restProps.required) !== null && _required !== void 0 ? _required : false,
            isClearable: (_isClearable = restProps.isClearable) !== null && _isClearable !== void 0 ? _isClearable : true,
            isSearchable: (_isSearchable = restProps.isSearchable) !== null && _isSearchable !== void 0 ? _isSearchable : true,
            isDisabled: (_isDisabled = restProps.isDisabled) !== null && _isDisabled !== void 0 ? _isDisabled : false,
            isLoading: (_isLoading = restProps.isLoading) !== null && _isLoading !== void 0 ? _isLoading : loading,
            loadingMessage: customLoadingMessage,
            isRtl: (_isRtl = restProps.isRtl) !== null && _isRtl !== void 0 ? _isRtl : false,
            name: (_name = restProps.name) !== null && _name !== void 0 ? _name : "select",
            onInputChange: handleInputChange,
            onChange: handleChange,
            formatGroupLabel: formatGroupLabel,
            noOptionsMessage: handleNoOptionsMessage,
            placeholder: restProps.placeholder ? restProps.placeholder : "Selecione uma op\xe7\xe3o",
            defaultValue: (ref5 = restProps === null || restProps === void 0 ? void 0 : (ref = restProps.options) === null || ref === void 0 ? void 0 : ref.filter(function(option) {
                return (option === null || option === void 0 ? void 0 : option.label) === (restProps === null || restProps === void 0 ? void 0 : restProps.defaultValue);
            })) !== null && ref5 !== void 0 ? ref5 : []
        })
    });
};
/* harmony default export */ var Select_Select2 = (Select2);


/***/ }),

/***/ 13266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hn": function() { return /* binding */ getLead; },
/* harmony export */   "K3": function() { return /* binding */ saveLead; },
/* harmony export */   "yu": function() { return /* binding */ saveLeadInHook; }
/* harmony export */ });
/* unused harmony exports getLeadById, getLeadByEmail */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var _services_endpoints_core_appAxiosService__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85325);
/* harmony import */ var _services_v2_leads__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39671);
/* harmony import */ var _services_v2_leads_DispathSaveHookLead__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53885);







function getLead() {
    return _getLead.apply(this, arguments);
}
function _getLead() {
    _getLead = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var context, dataLead, ls, lead;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    context = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : null;
                    if (false) {}
                    return [
                        4,
                        _services_endpoints_core_appAxiosService__WEBPACK_IMPORTED_MODULE_0__/* .nextApiAxios.get */ .Vm.get("/leads").then(function(data) {
                            return data.data;
                        }).catch(function(err) {
                            return false;
                        })
                    ];
                case 1:
                    dataLead = _state.sent();
                    return [
                        2,
                        dataLead
                    ];
                case 2:
                    // Server
                    if (!(context === null || context === void 0 ? void 0 : context.req)) {
                        return [
                            2,
                            null
                        ];
                    }
                    ls = new _services_v2_leads__WEBPACK_IMPORTED_MODULE_1__/* .LeadService */ .y(context === null || context === void 0 ? void 0 : context.req, context === null || context === void 0 ? void 0 : context.res);
                    return [
                        4,
                        ls.find()
                    ];
                case 3:
                    lead = _state.sent();
                    return [
                        2,
                        {
                            data: lead
                        }
                    ];
            }
        });
    });
    return _getLead.apply(this, arguments);
}
function getLeadById(_) {
    return _getLeadById.apply(this, arguments);
}
function _getLeadById() {
    _getLeadById = _async_to_generator(function(param) {
        var id, context, ls, lead;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    id = param.id, context = param.context;
                    if (true) {
                        throw Error("Apenas serverside");
                    }
                    ls = new LeadService(context === null || context === void 0 ? void 0 : context.req, context === null || context === void 0 ? void 0 : context.res);
                    return [
                        4,
                        ls.find(parseInt(id))
                    ];
                case 1:
                    lead = _state.sent();
                    return [
                        2,
                        {
                            data: lead
                        }
                    ];
            }
        });
    });
    return _getLeadById.apply(this, arguments);
}
function getLeadByEmail(_) {
    return _getLeadByEmail.apply(this, arguments);
}
function _getLeadByEmail() {
    _getLeadByEmail = _async_to_generator(function(param) {
        var email, context, ls, lead;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    email = param.email, context = param.context;
                    if (true) {
                        throw Error("Apenas serverside");
                    }
                    ls = new LeadService(context === null || context === void 0 ? void 0 : context.req, context === null || context === void 0 ? void 0 : context.res);
                    return [
                        4,
                        ls.findByEmail(email)
                    ];
                case 1:
                    lead = _state.sent();
                    return [
                        2,
                        {
                            data: lead
                        }
                    ];
            }
        });
    });
    return _getLeadByEmail.apply(this, arguments);
}
function saveLead(data) {
    return _saveLead.apply(this, arguments);
}
function _saveLead() {
    _saveLead = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(data) {
        var context, resultSavedLead, ls, resultSaveLead;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    context = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null;
                    if (false) {}
                    return [
                        4,
                        _services_endpoints_core_appAxiosService__WEBPACK_IMPORTED_MODULE_0__/* .nextApiAxios.post */ .Vm.post("/leads", data)
                    ];
                case 1:
                    resultSavedLead = _state.sent();
                    return [
                        2,
                        resultSavedLead.data
                    ];
                case 2:
                    // Server
                    if (!(context === null || context === void 0 ? void 0 : context.req)) {
                        return [
                            2,
                            null
                        ];
                    }
                    ls = new _services_v2_leads__WEBPACK_IMPORTED_MODULE_1__/* .LeadService */ .y(context.req, context.res);
                    return [
                        4,
                        ls.save(data)
                    ];
                case 3:
                    resultSaveLead = _state.sent();
                    return [
                        2,
                        resultSaveLead
                    ];
            }
        });
    });
    return _saveLead.apply(this, arguments);
}
function saveLeadInHook(data) {
    return _saveLeadInHook.apply(this, arguments);
}
function _saveLeadInHook() {
    _saveLeadInHook = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(data) {
        var context, ref, ref1, ref2, ref3, ref4, lead, ls, resultSaveLead;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    context = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null;
                    if (false) {}
                    return [
                        4,
                        _services_endpoints_core_appAxiosService__WEBPACK_IMPORTED_MODULE_0__/* .nextApiAxios.post */ .Vm.post("/hook-lead", data).then(function(data) {
                            return data.data;
                        }).catch(function(err) {
                            return err.message;
                        })
                    ];
                case 1:
                    // Client
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    return [
                        4,
                        getLead(context)
                    ];
                case 3:
                    lead = _state.sent();
                    if (!lead.data) {
                        return [
                            2,
                            false
                        ];
                    }
                    lead === null || lead === void 0 ? void 0 : (ref = lead.data) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : delete ref1.usina;
                    ls = new _services_v2_leads__WEBPACK_IMPORTED_MODULE_1__/* .LeadService */ .y(context.req, context.res);
                    return [
                        4,
                        ls.dispathSaveHookLead((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, data), {
                            pipe_id: lead === null || lead === void 0 ? void 0 : (ref2 = lead.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.attributes) === null || ref3 === void 0 ? void 0 : ref3.pipe_id,
                            id: lead === null || lead === void 0 ? void 0 : (ref4 = lead.data) === null || ref4 === void 0 ? void 0 : ref4.id,
                            json_form: lead.data
                        }))
                    ];
                case 4:
                    resultSaveLead = _state.sent();
                    return [
                        2,
                        resultSaveLead
                    ];
            }
        });
    });
    return _saveLeadInHook.apply(this, arguments);
}


/***/ }),

/***/ 3938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PK": function() { return /* binding */ cnpjMask; },
/* harmony export */   "Rx": function() { return /* binding */ number; },
/* harmony export */   "Tc": function() { return /* binding */ cepMask; },
/* harmony export */   "VL": function() { return /* binding */ cpfMask; },
/* harmony export */   "YU": function() { return /* binding */ cellMask; },
/* harmony export */   "es": function() { return /* binding */ validateCnpj; },
/* harmony export */   "o4": function() { return /* binding */ cell; },
/* harmony export */   "o_": function() { return /* binding */ formatBRL; },
/* harmony export */   "ou": function() { return /* binding */ emailMask; },
/* harmony export */   "pM": function() { return /* binding */ validateCPF; },
/* harmony export */   "s3": function() { return /* binding */ cnpj; },
/* harmony export */   "uo": function() { return /* binding */ validatePassword; },
/* harmony export */   "wn": function() { return /* binding */ cpf; }
/* harmony export */ });
function cell(e) {
    e.currentTarget.maxLength = 16;
    var val = e.currentTarget.value.replace(/\D/g, "").replace(/(\d{2})(\d)/, "($1) $2").replace(/(\d{1})(\d{4})(\d)/, "$1 $2-$3").replace(/(-\d{4})(\d+?)$/, "$1");
    e.currentTarget.value = val;
}
function cellMask(str) {
    var val = str.replace(/\D/g, "").replace(/(\d{2})(\d)/, "($1) $2").replace(/(\d{1})(\d{4})(\d)/, "$1$2-$3").replace(/(-\d{4})(\d+?)$/, "$1");
    return val;
}
function formatBRL(value) {
    var m = value;
    if (!value) return "";
    // Remove tudo que não for número
    var numeric = value.toString().replace(/\D/g, "");
    // Divide por 100 para considerar centavos
    var number = Number(numeric) / 100;
    return number.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
    });
}
function number(e) {
    var value = e.currentTarget.value;
    value = value.replace(/\D/g, "");
    e.currentTarget.value = value;
}
function validatePassword(eventOrValue) {
    var ref;
    var ref1;
    // /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#])[0-9a-zA-Z$*&@#]{8,}$/
    //   /^
    //   (?=.*\d)              // deve conter ao menos um dígito
    //   (?=.*[a-z])           // deve conter ao menos uma letra minúscula
    //   (?=.*[A-Z])           // deve conter ao menos uma letra maiúscula
    //   (?=.*[$*&@#])         // deve conter ao menos um caractere especial
    //   [0-9a-zA-Z$*&@#]{8,}  // deve conter ao menos 8 dos caracteres mencionados
    // $/
    var value = (ref1 = eventOrValue === null || eventOrValue === void 0 ? void 0 : (ref = eventOrValue.currentTarget) === null || ref === void 0 ? void 0 : ref.value) !== null && ref1 !== void 0 ? ref1 : eventOrValue;
    if (!value) {
        return true;
    }
    return /^(?=.*\d)(?=.*[A-Z])[0-9a-zA-Z$*&@#]{8,}$/.test(value);
}
function cpf(e) {
    var val = e.currentTarget.value.replace(/\D/g, "").replace(/(\d{3})(\d)/, "$1.$2") // pega 3 primeiros e o restante 000.
    .replace(/(\d{3})(\d)/, "$1.$2") // pega 3 primeiros e o restante 000.000.
    .replace(/(\d{3})(\d{1,2})/, "$1-$2") // pega 3 e no segundo só aceita 2 digitos separados por um hifen
    .replace(/(-\d{2})\d+?$/, "$1");
    return val;
}
function cpfMask(value) {
    var val = value.replace(/\D/g, "").replace(/(\d{3})(\d)/, "$1.$2") // pega 3 primeiros e o restante 000.
    .replace(/(\d{3})(\d)/, "$1.$2") // pega 3 primeiros e o restante 000.000.
    .replace(/(\d{3})(\d{1,2})/, "$1-$2") // pega 3 e no segundo só aceita 2 digitos separados por um hifen
    .replace(/(-\d{2})\d+?$/, "$1");
    return val;
}
function cepMask(value) {
    var cep = value;
    cep = cep.replace(/\D/g, "");
    cep = cep.replace(/(\d{5})(\d{1,3})$/, "$1-$2");
    return cep;
}
function cnpj(e) {
    // 99.999.999/9999-99
    e.currentTarget.maxLength = 18;
    var val = e.currentTarget.value.replace(/\D/g, "").replace(/(\d{2})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1/$2").replace(/(\d{4})(\d)/, "$1-$2");
    // .replace(/(-\d{2})\d+?$/, "$1-$2");
    return val;
}
function cnpjMask(value) {
    try {
        var val = value.replace(/\D/g, "").replace(/(\d{2})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1/$2").replace(/(\d{4})(\d)/, "$1-$2");
        // .replace(/(-\d{2})\d+?$/, "$1-$2");
        return val;
    } catch (error) {
        return "";
    }
}
function validateCPF(strCPF) {
    strCPF = strCPF.replace(/\D/g, "");
    if (strCPF.length != 11 || strCPF == "00000000000" || strCPF == "11111111111" || strCPF == "22222222222" || strCPF == "33333333333" || strCPF == "44444444444" || strCPF == "55555555555" || strCPF == "66666666666" || strCPF == "77777777777" || strCPF == "88888888888" || strCPF == "99999999999") return false;
    var Soma;
    var Resto;
    Soma = 0;
    if (strCPF == "00000000000") return false;
    for(var i = 1; i <= 9; i++)Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = Soma * 10 % 11;
    if (Resto == 10 || Resto == 11) Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10))) return false;
    Soma = 0;
    for(i = 1; i <= 10; i++)Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = Soma * 10 % 11;
    if (Resto == 10 || Resto == 11) Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11))) return false;
    return true;
}
function validateCnpj(strCnpj) {
    //https://www.geradorcnpj.com/javascript-validar-cnpj.htm#:~:text=Esta%20verificação%20é%20necessária%20uma,com%20o%20algoritmo%20do%20CNPJ.
    strCnpj = strCnpj.replace(/\D/g, "");
    if (strCnpj === "") return false;
    if (strCnpj.length !== 14) return false;
    // Elimina CNPJs invalidos conhecidos
    if (strCnpj == "00000000000000" || strCnpj == "11111111111111" || strCnpj == "22222222222222" || strCnpj == "33333333333333" || strCnpj == "44444444444444" || strCnpj == "55555555555555" || strCnpj == "66666666666666" || strCnpj == "77777777777777" || strCnpj == "88888888888888" || strCnpj == "99999999999999") return false;
    // Valida DVs
    var tamanho = strCnpj.length - 2;
    var numeros = strCnpj.substring(0, tamanho);
    var digitos = strCnpj.substring(tamanho);
    var soma = 0;
    var pos = tamanho - 7;
    for(var i = tamanho; i >= 1; i--){
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
    }
    var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0)) return false;
    tamanho = tamanho + 1;
    numeros = strCnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for(var i1 = tamanho; i1 >= 1; i1--){
        soma += numeros.charAt(tamanho - i1) * pos--;
        if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1)) return false;
    return true;
}
// Protege o email: joao@gmail.com -> +- jo***@gmail.com
function emailMask(email) {
    var maskedEmail = email.replace(/([^@\.])/g, "*").split("");
    var previous = "";
    var length = maskedEmail.length;
    for(var i = 0; i < length; i++){
        if (i < 2 || previous == "." || previous == "@") {
            maskedEmail[i] = email[i];
        }
        previous = email[i];
    }
    return maskedEmail.join("");
}


/***/ }),

/***/ 42563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ CalculadoraDesconto; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/pages/calculadora-desconto/components/CardForm2/styles.module.css
var styles_module = __webpack_require__(30974);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/services/wl/getUrls.js + 1 modules
var getUrls = __webpack_require__(22386);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Button/index.jsx
var Button = __webpack_require__(36201);
// EXTERNAL MODULE: ./src/components/ButtonIcon/index.jsx
var ButtonIcon = __webpack_require__(95416);
// EXTERNAL MODULE: ./src/functions/lang.js
var lang = __webpack_require__(88139);
// EXTERNAL MODULE: ./src/pages/usuario/components/ModalTitleText/index.jsx + 3 modules
var ModalTitleText = __webpack_require__(15494);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 13 modules
var createTheme = __webpack_require__(68239);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/ThemeProvider.js + 6 modules
var ThemeProvider = __webpack_require__(21407);
// EXTERNAL MODULE: ./node_modules/@mui/material/Slider/Slider.js + 6 modules
var Slider = __webpack_require__(91346);
// EXTERNAL MODULE: ./src/pages/calculadora-desconto/components/RangeMoney/styles.module.css
var RangeMoney_styles_module = __webpack_require__(59760);
var RangeMoney_styles_module_default = /*#__PURE__*/__webpack_require__.n(RangeMoney_styles_module);
;// CONCATENATED MODULE: ./src/pages/calculadora-desconto/components/RangeMoney/index.jsx






var DEFAULT_MAX_VALUE = 50000;
var DEFAULT_MIN_VALUE = 50;
var DEFAULT_INITIAL_VALUE = 150;
var DEFAULT_STEP_1 = 50;
var DEFAULT_STEP_2 = 2000;
var DEFAULT_STEP_3 = 5000;
var RangeMoney = function(props) {
    var reverseCalculateValue = function reverseCalculateValue(value) {
        if (value <= DEFAULT_STEP_2) {
            return Math.round((value - DEFAULT_STEP_1) / 5);
        } else if (value <= DEFAULT_STEP_3) {
            return Math.round((value - DEFAULT_STEP_2) / DEFAULT_STEP_1) + 389;
        } else {
            return Math.round((value - DEFAULT_STEP_3) / 100) + 453;
        }
    };
    var calculateValue = function calculateValue(value) {
        if (value <= 389) {
            return value * 5 + DEFAULT_STEP_1;
        } else if (value <= 699) {
            return (value - 389) * DEFAULT_STEP_1 + DEFAULT_STEP_2;
        } else {
            return (value - 453) * 100 + DEFAULT_STEP_3;
        }
    };
    var _max;
    var maxInputValue = (_max = props.max) !== null && _max !== void 0 ? _max : DEFAULT_MAX_VALUE;
    var maxSlideValue = reverseCalculateValue(maxInputValue);
    var min = DEFAULT_MIN_VALUE;
    var max = maxSlideValue;
    var _defaultValue;
    var defaultValue = reverseCalculateValue((_defaultValue = props.defaultValue) !== null && _defaultValue !== void 0 ? _defaultValue : DEFAULT_INITIAL_VALUE);
    var ref = (0,react.useState)(defaultValue), value = ref[0], setPositionSlider = ref[1];
    var ref1 = (0,react.useState)(calculateValue(defaultValue)), realValue = ref1[0], setRealValue = ref1[1];
    var theme = (0,createTheme/* default */.Z)({
        palette: {
            primary: {
                main: props.wl.cor_tema_primaria
            },
            customColor: {
                main: "#b6b8b7",
                focus: props.wl.cor_tema_3
            }
        }
    });
    function updateValue(_) {
        return _updateValue.apply(this, arguments);
    }
    function _updateValue() {
        _updateValue = (0,_async_to_generator/* default */.Z)(function(param) {
            var newInputValue, newSliderValue, newValue;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        newInputValue = param.newInputValue, newSliderValue = param.newSliderValue;
                        if (newInputValue > 0) {
                            if (newInputValue[0] === "0") {
                                newInputValue = newInputValue.slice(1);
                            }
                            setRealValue(newInputValue);
                            setPositionSlider(reverseCalculateValue(newInputValue));
                            newValue = newInputValue;
                        } else if (newSliderValue > 0) {
                            setRealValue(calculateValue(newSliderValue));
                            setPositionSlider(newSliderValue);
                            newValue = calculateValue(newSliderValue);
                        } else {
                            // reset
                            setRealValue("0");
                            setPositionSlider(0);
                            newValue = 0;
                        }
                        if (!props.handleUpdateValue) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            props === null || props === void 0 ? void 0 : props.handleUpdateValue(newValue)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return _updateValue.apply(this, arguments);
    }
    var handlePosition = function(e, newValue) {
        updateValue({
            newSliderValue: newValue
        });
    };
    var handleChange = function(e) {
        var inputValue = e.target.value;
        inputValue = inputValue.substring(0, inputValue.length - 2);
        if (inputValue.startsWith("0")) {
            inputValue = inputValue.substring(1);
        }
        if (!inputValue) {
            inputValue = "0";
        }
        inputValue = inputValue.replace(/\D/g, "");
        if (inputValue > calculateValue(max)) {
            inputValue = maxInputValue;
        }
        updateValue({
            newInputValue: inputValue
        });
        setTimeout(function() {
            e.target.setSelectionRange(e.target.value.length - 3, e.target.value.length - 3);
        }, 1);
    };
    // const checkValue = () => {
    //   const _realValue = calculateValue(value);
    //   if (reverseCalculateValue(_realValue) < min) {
    //     updateValue({newInputValue: DEFAULT_MIN_VALUE})
    //   } else if (reverseCalculateValue(_realValue) > max) {
    //     updateValue({newSliderValue: max});
    //   }
    // };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
            theme: theme,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                    className: (RangeMoney_styles_module_default())["text-value"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mobile__p5",
                            children: " Valor da minha conta: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            className: "mobile__h5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "text",
                                        min: 50,
                                        max: max,
                                        value: "R$ ".concat(realValue, ",00"),
                                        // onKeyDown={(e) =>handleKeyUp(e)}
                                        onChange: handleChange,
                                        ref: props.ref,
                                        // onBlur={checkValue}
                                        onFocus: function(e) {
                                            // updateValue({newSliderValue: 0});
                                            setTimeout(function() {
                                                e.target.setSelectionRange(e.target.value.length - 3, e.target.value.length - 3);
                                            }, 10);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "hidden",
                                        name: props.name,
                                        value: realValue
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (RangeMoney_styles_module_default()).slider,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.ZP, {
                        size: "small",
                        sx: [
                            {
                                "&.MuiSlider-root": {
                                    boxShadow: "0 0 0.5rem ".concat(props.wl.cor_tema_botao_solido),
                                    padding: "6px",
                                    outline: 0,
                                    background: "var(--white-100)"
                                },
                                "& .MuiSlider-track": {
                                    left: "-3px!important",
                                    right: "-3px!important",
                                    background: props.wl.cor_tema_3,
                                    padding: "6px",
                                    border: "none"
                                },
                                "& .MuiSlider-rail": {
                                    width: "calc(100% - 10px)!important",
                                    background: "transparent",
                                    left: "5px",
                                    right: "5px"
                                },
                                "& .MuiSlider-valueLabel": {
                                    background: "transparent",
                                    padding: "0"
                                },
                                "& .MuiSlider-thumb": {
                                    left: 100 / maxSlideValue * value + "%!important"
                                }
                            }, 
                        ],
                        valueLabelDisplay: "on",
                        valueLabelFormat: function() {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "14",
                                height: "24",
                                viewBox: "0 0 14 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M3.98583 24L5.31916 14.6667H0.652497C0.319164 14.6667 0.113386 14.5778 0.0351638 14.4C-0.0421695 14.2222 0.00805255 13.9778 0.18583 13.6667L7.98583 0H9.31916L7.98583 9.33333H12.6525C12.9858 9.33333 13.1912 9.42222 13.2685 9.6C13.3467 9.77778 13.2969 10.0222 13.1192 10.3333L5.31916 24H3.98583Z",
                                    fill: props.wl.cor_tema_primaria
                                })
                            });
                        },
                        step: 1,
                        min: 0,
                        max: maxSlideValue,
                        scale: calculateValue,
                        defaultValue: defaultValue,
                        value: value,
                        onChange: handlePosition,
                        color: theme.palette.customColor.pointerSlider
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_RangeMoney = (RangeMoney);

// EXTERNAL MODULE: ./src/pages/calculadora-desconto/components/FormNovaJornada/styles.module.css
var FormNovaJornada_styles_module = __webpack_require__(93283);
var FormNovaJornada_styles_module_default = /*#__PURE__*/__webpack_require__.n(FormNovaJornada_styles_module);
;// CONCATENATED MODULE: ./src/components/Icon/IconBusiness/index.jsx


function IconBusiness(props) {
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.77049 4.48481C9.17235 4.08294 9.71739 3.85718 10.2857 3.85718H13.7143C14.2826 3.85718 14.8277 4.08294 15.2295 4.48481C15.6314 4.88667 15.8571 5.43171 15.8571 6.00004V7.28575H18.8571C20.0406 7.28575 21 8.24514 21 9.42861V18C21 19.1835 20.0406 20.1429 18.8571 20.1429H5.14286C3.95939 20.1429 3 19.1835 3 18V9.42861C3 8.24514 3.95939 7.28575 5.14286 7.28575H8.14286V6.00004C8.14286 5.43171 8.36862 4.88667 8.77049 4.48481ZM8.14286 8.14289H5.14286C4.43278 8.14289 3.85714 8.71853 3.85714 9.42861V18C3.85714 18.7101 4.43278 19.2858 5.14286 19.2858H8.14286V8.14289ZM9 19.2858V8.14289H15V19.2858H9ZM15.8571 19.2858H18.8571C19.5672 19.2858 20.1429 18.7101 20.1429 18V9.42861C20.1429 8.71853 19.5672 8.14289 18.8571 8.14289H15.8571V19.2858ZM15 7.28575H9V6.00004C9 5.65904 9.13546 5.33202 9.37658 5.0909C9.6177 4.84978 9.94472 4.71432 10.2857 4.71432H13.7143C14.0553 4.71432 14.3823 4.84978 14.6234 5.0909C14.8645 5.33202 15 5.65904 15 6.00004V7.28575Z",
            fill: props.bgded ? props.color ? props.color : props === null || props === void 0 ? void 0 : (ref = props.wl) === null || ref === void 0 ? void 0 : ref.cor_texto_botao : props.color ? props.color : props === null || props === void 0 ? void 0 : (ref1 = props.wl) === null || ref1 === void 0 ? void 0 : ref1.cor_tema_secundaria
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Icon/IconUser/index.jsx


function IconUser(props) {
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 0.988118C5.65216 0.988118 4.55953 2.08076 4.55953 3.42859C4.55953 4.77643 5.65216 5.86907 7 5.86907C8.34784 5.86907 9.44048 4.77643 9.44048 3.42859C9.44048 2.08076 8.34784 0.988118 7 0.988118ZM3.72619 3.42859C3.72619 1.62052 5.19193 0.154785 7 0.154785C8.80808 0.154785 10.2738 1.62052 10.2738 3.42859C10.2738 5.23667 8.80808 6.7024 7 6.7024C5.19193 6.7024 3.72619 5.23667 3.72619 3.42859ZM1.82793 9.68509C2.44188 9.07113 3.27459 8.72621 4.14286 8.72621H9.85714C10.7254 8.72621 11.5581 9.07113 12.1721 9.68509C12.786 10.299 13.131 11.1318 13.131 12V13.4286C13.131 13.6587 12.9444 13.8453 12.7143 13.8453C12.4842 13.8453 12.2976 13.6587 12.2976 13.4286V12C12.2976 11.3528 12.0405 10.732 11.5828 10.2743C11.1251 9.81667 10.5044 9.55955 9.85714 9.55955H4.14286C3.4956 9.55955 2.87486 9.81667 2.41718 10.2743C1.9595 10.732 1.70238 11.3528 1.70238 12V13.4286C1.70238 13.6587 1.51583 13.8453 1.28572 13.8453C1.0556 13.8453 0.869049 13.6587 0.869049 13.4286V12C0.869049 11.1318 1.21397 10.299 1.82793 9.68509Z",
            fill: props.bgded ? props.color ? props.color : props === null || props === void 0 ? void 0 : (ref = props.wl) === null || ref === void 0 ? void 0 : ref.cor_texto_botao : props.color ? props.color : props === null || props === void 0 ? void 0 : (ref1 = props.wl) === null || ref1 === void 0 ? void 0 : ref1.cor_tema_secundaria
        })
    });
}

// EXTERNAL MODULE: ./src/components/Select/Select2/index.jsx + 1 modules
var Select2 = __webpack_require__(41870);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/functions/find-municipios.js



var handleFindOptionsMunicipios = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var valueMunicipio, city, newarray;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    valueMunicipio = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "";
                    return [
                        4,
                        axios_default().post("/api/municipios/get-municipios-by-caracter", {
                            cidade: valueMunicipio,
                            withRelation: "concessionarias"
                        })
                    ];
                case 1:
                    city = _state.sent();
                    newarray = [];
                    // const array = data.data;
                    city.data.map(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                            var objCidades;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                objCidades = [];
                                item.cidades.map(function(c) {
                                    var ref;
                                    var ref1;
                                    objCidades.push({
                                        value: "".concat(c.attributes.nome, " - ").concat(c.attributes.uf),
                                        label: "".concat(c.attributes.nome, " - ").concat(c.attributes.uf),
                                        concessionarias: (ref1 = (ref = c.attributes.concessionarias) === null || ref === void 0 ? void 0 : ref.data) !== null && ref1 !== void 0 ? ref1 : [],
                                        id: "".concat(c.id)
                                    });
                                });
                                newarray.push({
                                    label: item.nome,
                                    options: objCidades
                                });
                                return [
                                    2
                                ];
                            });
                        });
                        return function(item) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    return [
                        2,
                        newarray
                    ];
            }
        });
    });
    return function handleFindOptionsMunicipios() {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/functions/usinas/CalcularValorDescontoAnual.js
function calcularValorDescontoAnual(param) {
    var consumoDinheiro = param.consumoDinheiro, porcentagem = param.porcentagem;
    var MESES_ANO = 12;
    return consumoDinheiro * MESES_ANO * porcentagem;
}

;// CONCATENATED MODULE: ./src/functions/usinas/ConfigureLeadMercadoLivre.js



/**
 * Obtém um Object configurado com base na informação de consumoDinheiro:
 * - caso seja possível contratar ML, o json será: { elegivel: true, valorDesconto: XX }
 * - caso não seja possível contratar ML, o json será: { elegivel: false }
 * Para ser elegível ao ML - Mercado Livre, é necessário ser PJ, estar habilidado contratação ML e ter consumo mínimo suficiente
 * @param {'pf'|'pj'} tipoConta Valor em R$ do consumo médio de energia  
 * @param {number} consumoDinheiro Valor em R$ do consumo médio de energia  
 * @param {object} infos -> tabela de configurações do sistema
 * @returns {object} -> { elegivel: true|false, valorDesconto: number }
 */ function ConfigureLeadMercadoLivre(param) {
    var tipoConta = param.tipoConta, consumoDinheiro = param.consumoDinheiro, infos = param.infos;
    // garantindo acesso correto para "infos"
    var info = getInfoAttributesByInfosData({
        infos: infos
    });
    return getDataDescontoElegivelMercadoLivre({
        tipoConta: tipoConta,
        consumoDinheiro: consumoDinheiro,
        info: info
    });
}
/**
 * Valida Elegibilidade de contratação para Mercado Livre calculando valor do desconto, caso elegível
 * @param {pf|pj} tipoConta 
 * @param {number} consumoDinheiro 
 * @param {Object} info -> Dados da Tabela de Infos: {ml_enabled, ml_min_value, ml_min_value, ml_valor_kwh, ml_desconto}
 * @returns 
 */ function getDataDescontoElegivelMercadoLivre(param) {
    var tipoConta = param.tipoConta, consumoDinheiro = param.consumoDinheiro, info = param.info;
    // somente PJ pode contratar ML
    if (!info || tipoConta != "pj") {
        return {
            elegivel: false
        };
    }
    // precisa estar habilitado contratação via ML
    if (!info.ml_enabled) {
        return {
            elegivel: false
        };
    }
    // precisa ter os campos calculáveis configurados corretamente
    if (!info.ml_min_value || !info.ml_desconto || info.ml_desconto <= 0) {
        return {
            elegivel: false
        };
    }
    // calculando valor do desconto
    // const consumoKwh = calcularConsumoKwh({ consumoDinheiro, valorKwh: info?.ml_valor_kwh });// VALOR CONFIGURADO NO ML É EM R$
    if (consumoDinheiro < info.ml_min_value) {
        return {
            elegivel: false
        };
    }
    var valorDesconto = calcularValorDescontoAnual({
        consumoDinheiro: consumoDinheiro,
        porcentagem: info.ml_desconto
    });
    return {
        elegivel: true,
        valorDesconto: valorDesconto
    };
}

;// CONCATENATED MODULE: ./src/functions/usinas/IsValidTipoConta.js
/**
 * Valida se o tipo de conta informado é válido: se for diferente de 'pf' e diferente de 'pj', é considerado inválido
 * @param {str} tipoConta -> esperado 'pf' ou 'pj'.
 * @returns {boolean} true|false
 */ function isValidTipoConta(tipoConta) {
    return tipoConta == "pf" || tipoConta == "pj";
}

;// CONCATENATED MODULE: ./src/functions/usinas/FiltrarMelhorContratoPlanoUsina.js



/**
 * Retorna o melhor contrato_plano_usina disponível com base no valor de desconto para o tipo de conta ou null, caso não haja * @param {planoUsinas} Array -> array de plano-usinas, populado com contrato_plano_usinas, usina, usina.concessionaria.
 * @param {tipoConta} 'pj'|'pf' -> tipo de conta do usuário: pessoa jurídica, pessoa física
 * @returns 
 */ function filtrarMelhorContratoPlanoUsina(param) {
    var planoUsinas = param.planoUsinas, tipoConta = param.tipoConta;
    var ref, ref1, ref2, ref3, ref4, ref5;
    if (!isValidTipoConta(tipoConta)) {
        return null;
    }
    if (planoUsinas.length < 1) {
        return null;
    }
    var melhorContratoPlano;
    var planoUsina;
    var contratoPlanoUsinas;
    var contratoPlanoUsina;
    var usina;
    for(var i = 0; i < planoUsinas.length; i++){
        var ref6, ref7;
        planoUsina = planoUsinas[i];
        contratoPlanoUsinas = planoUsina === null || planoUsina === void 0 ? void 0 : (ref6 = planoUsina.attributes) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.contrato_plano_usinas) === null || ref7 === void 0 ? void 0 : ref7.data;
        for(var j = 0; j < contratoPlanoUsinas.length; j++){
            var ref8, ref9;
            contratoPlanoUsina = contratoPlanoUsinas[j];
            if (!melhorContratoPlano || ((ref8 = contratoPlanoUsina.attributes) === null || ref8 === void 0 ? void 0 : ref8["desconto_porcentagem_".concat(tipoConta)]) > ((ref9 = melhorContratoPlano.attributes) === null || ref9 === void 0 ? void 0 : ref9["desconto_porcentagem_".concat(tipoConta)])) {
                var ref10, ref11;
                melhorContratoPlano = contratoPlanoUsina;
                usina = planoUsinas === null || planoUsinas === void 0 ? void 0 : (ref10 = planoUsinas[i]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.attributes) === null || ref11 === void 0 ? void 0 : ref11.usina;
            }
        }
    }
    delete melhorContratoPlano.attributes.nome;
    // melhorContratoPlano.usina = usina;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, melhorContratoPlano), {
        attributes: (0,_object_spread/* default */.Z)({
            nome_gerador_integrado: (ref = usina.data) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.nome_sharpspring,
            nome_gerador_interno: (ref2 = usina.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.attributes) === null || ref3 === void 0 ? void 0 : ref3.nome,
            nome: (ref4 = usina.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.attributes) === null || ref5 === void 0 ? void 0 : ref5.nome
        }, melhorContratoPlano.attributes)
    });
}

;// CONCATENATED MODULE: ./src/functions/usinas/CalcularConsumoKWH.js
function calcularConsumoKwh(param) {
    var consumoDinheiro = param.consumoDinheiro, valorKwh = param.valorKwh;
    return Math.floor(consumoDinheiro * valorKwh);
}
;

;// CONCATENATED MODULE: ./src/functions/usinas/FiltrarPlanoUsinasContrataveis.js




/**
 * Para ser possível filtrar planos contratáveis com base no "consumoDinheiro", precisa ter populado usina e em usina, concessionária nos planoUsinas
 */ function filtrarPlanoUsinasContrataveis(_) {
    return _filtrarPlanoUsinasContrataveis.apply(this, arguments);
}
function _filtrarPlanoUsinasContrataveis() {
    _filtrarPlanoUsinasContrataveis = (0,_async_to_generator/* default */.Z)(function(param) {
        var planoUsinas, consumoDinheiro, tipoConta, concessionariaId, concessionaria, valorKwh, consumoKwh;
        return (0,tslib_es6.__generator)(this, function(_state) {
            planoUsinas = param.planoUsinas, consumoDinheiro = param.consumoDinheiro, tipoConta = param.tipoConta, concessionariaId = param.concessionariaId;
            if (planoUsinas.length < 1) {
                return [
                    2,
                    []
                ];
            }
            if (!isValidTipoConta(tipoConta)) {
                return [
                    2,
                    []
                ];
            }
            concessionaria = getConcessionaria({
                planoUsina: planoUsinas[0],
                concessionariaId: concessionariaId
            });
            if (!concessionaria) {
                return [
                    2,
                    []
                ];
            }
            valorKwh = concessionaria.attributes["valor_kwh_".concat(tipoConta)];
            consumoKwh = calcularConsumoKwh({
                consumoDinheiro: Number(consumoDinheiro),
                valorKwh: valorKwh
            });
            return [
                2,
                planoUsinas.filter(function(planoUsina) {
                    var ref, ref1, ref2, ref3;
                    return !(((ref = planoUsina.attributes) === null || ref === void 0 ? void 0 : ref["consumo_minimo_kw_".concat(tipoConta)]) > consumoKwh // consumo precisa ser compatível
                    ) && ((ref1 = planoUsina.attributes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.contrato_plano_usinas) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 // para ser contratável, precisa haver ao menos um contrato_plano_usina
                    ;
                })
            ];
        });
    });
    return _filtrarPlanoUsinasContrataveis.apply(this, arguments);
}
// Retorna a concessionária contida no plano
function getConcessionaria(param) {
    var planoUsina = param.planoUsina, concessionariaId = param.concessionariaId;
    var ref, ref1, ref2, ref3, ref4;
    var ref5;
    // Quando modificar relacionamento concessionaria <> usina para manyToMany, trabalhar concessionariaId
    return (ref5 = (ref = planoUsina.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.usina) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.attributes) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.concessionaria) === null || ref4 === void 0 ? void 0 : ref4.data) !== null && ref5 !== void 0 ? ref5 : null;
}

;// CONCATENATED MODULE: ./src/functions/usinas/FiltrarPlanoUsinasDisponiveisTipoPfPj.js



function filtrarPlanoUsinasDisponiveisTipoPfPj(_) {
    return _filtrarPlanoUsinasDisponiveisTipoPfPj.apply(this, arguments);
}
function _filtrarPlanoUsinasDisponiveisTipoPfPj() {
    _filtrarPlanoUsinasDisponiveisTipoPfPj = (0,_async_to_generator/* default */.Z)(function(param) {
        var planoUsinas, tipoConta;
        return (0,tslib_es6.__generator)(this, function(_state) {
            planoUsinas = param.planoUsinas, tipoConta = param.tipoConta;
            if (planoUsinas.length < 1) {
                return [
                    2,
                    []
                ];
            }
            if (!isValidTipoConta(tipoConta)) {
                return [
                    2,
                    []
                ];
            }
            return [
                2,
                planoUsinas.filter(function(planoUsina) {
                    var ref;
                    return ((ref = planoUsina.attributes) === null || ref === void 0 ? void 0 : ref["consumo_minimo_kw_".concat(tipoConta)]) != 0 // consumo precisa diferente de 0 - Habilitado
                    ;
                })
            ];
        });
    });
    return _filtrarPlanoUsinasDisponiveisTipoPfPj.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/pages/calculadora-desconto/components/FormNovaJornada/configSimulacao.jsx









var statusSimulacao = {
    empty_inputs: "empty_inputs",
    regiao_nao_atendida: "regiao_nao_atendida",
    sem_estoque: "sem_estoque",
    sem_consumo_minimo: "sem_consumo_minimo",
    tipo_pf_pj_indisponivel: "tipo_pf_pj_indisponivel",
    zero_value: "zero_value"
};
var configSimulacao = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var formData, setFormData, concessionariaId, ref, ref1, ref2, ref3, ref4, ref5, ref6, _dataConfigOfertas, mlRules, planoUsinasConcessionarias, planoUsinasDisponiveis, dataMercadoLivre, planoUsinasDisponiveisTipoPfPj, planoUsinasContrataveis, melhorContratoPlanoUsina, valorDesconto;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    formData = param.formData, setFormData = param.setFormData, concessionariaId = param.concessionariaId;
                    if ((formData === null || formData === void 0 ? void 0 : formData.valorConsumo) == 0) {
                        return [
                            2,
                            setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                dataDiscount: dataDescontoFail(statusSimulacao.zero_value)
                            }))
                        ];
                    }
                    if (!(formData === null || formData === void 0 ? void 0 : (ref = formData.selectedTypeButton) === null || ref === void 0 ? void 0 : ref.selected) || !formData.valorConsumo || !(formData === null || formData === void 0 ? void 0 : formData.dataConfigOfertas)) {
                        return [
                            2,
                            setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                dataDiscount: dataDescontoFail(statusSimulacao.empty_inputs)
                            }))
                        ];
                    }
                    _dataConfigOfertas = formData.dataConfigOfertas, mlRules = _dataConfigOfertas.mlRules, planoUsinasConcessionarias = _dataConfigOfertas.planoUsinasConcessionarias, planoUsinasDisponiveis = _dataConfigOfertas.planoUsinasDisponiveis;
                    return [
                        4,
                        getDataDescontoElegivelMercadoLivre({
                            tipoConta: formData === null || formData === void 0 ? void 0 : (ref1 = formData.selectedTypeButton) === null || ref1 === void 0 ? void 0 : ref1.selected,
                            consumoDinheiro: formData.valorConsumo,
                            info: mlRules
                        })
                    ];
                case 1:
                    dataMercadoLivre = _state.sent();
                    if (dataMercadoLivre.elegivel) {
                        return [
                            2,
                            setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                dataDiscount: dataDescontoOk(dataMercadoLivre.valorDesconto)
                            }))
                        ];
                    }
                    if (!isRegiaoAtendida({
                        planoUsinasConcessionarias: planoUsinasConcessionarias
                    })) {
                        return [
                            2,
                            setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                dataDiscount: dataDescontoFail(statusSimulacao.regiao_nao_atendida)
                            }))
                        ];
                    }
                    if (!hasStock({
                        planoUsinasDisponiveis: planoUsinasDisponiveis
                    })) {
                        return [
                            2,
                            setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                dataDiscount: dataDescontoFail(statusSimulacao.sem_estoque)
                            }))
                        ];
                    }
                    return [
                        4,
                        filtrarPlanoUsinasDisponiveisTipoPfPj({
                            planoUsinas: planoUsinasDisponiveis,
                            tipoConta: formData === null || formData === void 0 ? void 0 : (ref2 = formData.selectedTypeButton) === null || ref2 === void 0 ? void 0 : ref2.selected
                        })
                    ];
                case 2:
                    planoUsinasDisponiveisTipoPfPj = _state.sent();
                    if (planoUsinasDisponiveisTipoPfPj.length === 0) {
                        return [
                            2,
                            setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                dataDiscount: dataDescontoFail(statusSimulacao.tipo_pf_pj_indisponivel)
                            }))
                        ];
                    }
                    return [
                        4,
                        filtrarPlanoUsinasContrataveis({
                            planoUsinas: planoUsinasDisponiveisTipoPfPj,
                            consumoDinheiro: formData.valorConsumo,
                            concessionariaId: concessionariaId,
                            tipoConta: formData === null || formData === void 0 ? void 0 : (ref3 = formData.selectedTypeButton) === null || ref3 === void 0 ? void 0 : ref3.selected
                        })
                    ];
                case 3:
                    planoUsinasContrataveis = _state.sent();
                    if (planoUsinasContrataveis.length == 0) {
                        return [
                            2,
                            setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                dataDiscount: dataDescontoFail(statusSimulacao.sem_consumo_minimo)
                            }))
                        ];
                    }
                    return [
                        4,
                        filtrarMelhorContratoPlanoUsina({
                            planoUsinas: planoUsinasContrataveis,
                            tipoConta: formData === null || formData === void 0 ? void 0 : (ref4 = formData.selectedTypeButton) === null || ref4 === void 0 ? void 0 : ref4.selected
                        })
                    ];
                case 4:
                    melhorContratoPlanoUsina = _state.sent();
                    valorDesconto = calcularValorDescontoAnual({
                        porcentagem: (ref6 = melhorContratoPlanoUsina.attributes) === null || ref6 === void 0 ? void 0 : ref6["desconto_porcentagem_".concat(formData === null || formData === void 0 ? void 0 : (ref5 = formData.selectedTypeButton) === null || ref5 === void 0 ? void 0 : ref5.selected)],
                        consumoDinheiro: formData.valorConsumo
                    });
                    // if (valorDesconto <= 0) {
                    //   return setFormData({
                    //     ...formData,
                    //     dataDiscount: dataDescontoFail(statusSimulacao.sem_consumo_minimo),
                    //   });
                    // }
                    setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                        dataDiscount: dataDescontoOk(valorDesconto)
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return function configSimulacao(_) {
        return _ref.apply(this, arguments);
    };
}();
function isRegiaoAtendida(param) {
    var planoUsinasConcessionarias = param.planoUsinasConcessionarias;
    if (!planoUsinasConcessionarias) {
        return false;
    }
    if (planoUsinasConcessionarias.length == 0) {
        return false;
    }
    return true;
}
function hasStock(param) {
    var planoUsinasDisponiveis = param.planoUsinasDisponiveis;
    if (!planoUsinasDisponiveis) {
        return false;
    }
    if (planoUsinasDisponiveis.length == 0) {
        return false;
    }
    return true;
}
function dataDescontoFail(message) {
    return {
        status: false,
        message: message
    };
}
function dataDescontoOk(valorDescontoAnual) {
    return {
        status: true,
        valorDescontoAnual: Math.round(valorDescontoAnual)
    };
}

;// CONCATENATED MODULE: ./src/pages/calculadora-desconto/components/FormNovaJornada/findPlanosDescontos.jsx

function findPlanosDescontos(param) {
    var concessionariaId = param.concessionariaId;
    return axios_default().post("/api/simulacao", {
        concessionariaId: concessionariaId
    }).then(function(data) {
        return data.data;
    }).catch(function() {
        return [];
    });
}

;// CONCATENATED MODULE: ./src/pages/calculadora-desconto/components/FormNovaJornada/getResultMessages.jsx



function getResultDiscountMessage(value, corTema) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: (FormNovaJornada_styles_module_default()).msgDiscount,
        children: [
            "Voc\xea pode economizar at\xe9 ",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                style: {
                    color: corTema
                },
                children: parseFloat(value).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL"
                })
            }),
            " ",
            " ",
            "por ano"
        ]
    });
}
function getResultFailMessage(status) {
    var messages = {};
    messages[statusSimulacao.empty_inputs] = "";
    messages[statusSimulacao.regiao_nao_atendida] = "Regi\xe3o n\xe3o atendida no momento";
    messages[statusSimulacao.sem_consumo_minimo] = "Consumo insuficiente para obter descontos";
    messages[statusSimulacao.sem_estoque] = "Regi\xe3o sem estoque dispon\xedvel";
    messages[statusSimulacao.tipo_pf_pj_indisponivel] = "Tipo de contrata\xe7\xe3o n\xe3o dispon\xedvel no momento";
    messages[statusSimulacao.zero_value] = "Informe o valor da conta";
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (FormNovaJornada_styles_module_default()).msgDiscountError,
        children: (ref = messages === null || messages === void 0 ? void 0 : messages[status]) !== null && ref !== void 0 ? ref : ""
    });
}

// EXTERNAL MODULE: ./src/functions/leads/index.js
var leads = __webpack_require__(13266);
// EXTERNAL MODULE: ./src/functions/cookies/COOKIES_TAGS.js
var COOKIES_TAGS = __webpack_require__(89368);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(47041);
;// CONCATENATED MODULE: ./src/pages/calculadora-desconto/components/FormNovaJornada/index.jsx

























/**
 * Formulário da Calculadora
 *
 * - Campos adicionais poderão ser adicionados com prefixo "ef_": Extra Field.
 * Ex: `https://app.electy.com.br/calculadora-desconto?type=form&ef_campo1=123&ef_campo2=456`
 *
 * No exemplo temos os campos ef_campo1 e ef_campo2 adicionados e incorporados dinamicamente
 */ var FormNovaJornada = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
    // Valida se deve aparecer opções para selecionar "PF"|"PJ"
    var oneOptionContractEnabled = props.wl.Calculadora.habilitar_contrato_pf && !props.wl.Calculadora.habilitar_contrato_pj ? "pf" : props.wl.Calculadora.habilitar_contrato_pj && !props.wl.Calculadora.habilitar_contrato_pf ? "pj" : false;
    var ref19 = (0,react.useState)(false), isLoading = ref19[0], setIsLoading = ref19[1];
    var ref20 = (0,react.useState)({
        valorConsumo: 150,
        dataDiscount: "",
        dataConfigOfertas: null,
        selectedConcessionaria: null,
        submitButtonChildren: "QUERO SABER MAIS",
        errorMessage: "",
        concessionariasMunicipio: [],
        selectedTypeButton: {
            selected: oneOptionContractEnabled ? oneOptionContractEnabled : "",
            pf: "",
            pj: ""
        }
    }), formData = ref20[0], setFormData = ref20[1];
    var handleSelectTipoPessoa = function(type) {
        setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
            selectedTypeButton: {
                pf: type == "pf" ? "selected" : "",
                pj: type == "pj" ? "selected" : "",
                selected: type
            }
        }));
        setErrorMessage("");
    };
    var ref21 = (0,react.useState)(null), selectedConcessionaria = ref21[0], setSelectedConcessionaria = ref21[1];
    // const enableSharp = props.infos.usa_sharpspring;
    var ref22 = (0,react.useState)("QUERO SABER MAIS"), submitButtonChildren = ref22[0], setSubmitButtonChildren = ref22[1];
    var ref23 = (0,react.useState)(""), errorMessage = ref23[0], setErrorMessage = ref23[1];
    var ref24 = (0,react.useState)([]), concessionariasMunicipio = ref24[0], setConcessionariasMunicipio = ref24[1];
    // Cada campo não preenchido é recebido nessa função: Se algum estiver na lista de bloqueados, a chamada é interrompida
    var hasInvalidInputs = function(e) {
        if (e.target.getAttribute("name") == "tipoConta") {
            setErrorMessage("Selecione o tipo da conta!");
            return true;
        }
        if (e.target.getAttribute("name") == "concessionaria") {
            setErrorMessage("Selecione a concession\xe1ria!");
            return true;
        }
        return false;
    };
    var imgSplash = (0,getUrls/* getUrls */.U)((ref = props.wl) === null || ref === void 0 ? void 0 : (ref1 = ref.splash) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.attributes) === null || ref3 === void 0 ? void 0 : ref3.url);
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var formData, formElements, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, savedLead, ref, municipioEstado, municipio, uf, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        formData = {};
                        formElements = e.target.elements;
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = formElements[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                element = _step.value;
                                if (element.name) {
                                    formData[element.name] = element.value;
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        savedLead = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        municipioEstado = (ref = formData.municipio) === null || ref === void 0 ? void 0 : ref.split(" - ");
                        municipio = municipioEstado === null || municipioEstado === void 0 ? void 0 : municipioEstado[0];
                        uf = municipioEstado === null || municipioEstado === void 0 ? void 0 : municipioEstado[1];
                        (0,lib.deleteCookie)(COOKIES_TAGS/* COOKIES_TAGS.LEAD_ID */.t.LEAD_ID);
                        return [
                            4,
                            (0,leads/* saveLead */.K3)({
                                assessor: formData.ef_assessor || formData.ef_parceiro,
                                campanha: formData.representante,
                                municipio: municipio,
                                uf: uf,
                                concessionaria: Number(formData.concessionaria),
                                tipo: formData.tipoConta,
                                valor_consumo: formData.money
                            })
                        ];
                    case 2:
                        savedLead = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log({
                            error: error
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setIsLoading(true);
                        setTimeout(function() {
                            setIsLoading(false);
                        }, 10000);
                        router_default().push("/form-dados-pessoais");
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var bgSubmitButton = submitButtonChildren != "QUERO SABER MAIS" || !(formData === null || formData === void 0 ? void 0 : formData.dataDiscount.status) ? {
        background: "transparent"
    } : {
        color: (ref4 = props.wl) === null || ref4 === void 0 ? void 0 : ref4.cor_texto_botao,
        background: ((ref5 = props.wl) === null || ref5 === void 0 ? void 0 : ref5.cor_tema_botao_solido) ? (ref6 = props.wl) === null || ref6 === void 0 ? void 0 : ref6.cor_tema_botao_solido : "1"
    };
    /**
   * Configura a option de concessionária para o Lead
   */ var handleMunicipioChange = function(_selectedMunicipio) {
        var ref;
        var concessionariaOptions = [];
        _selectedMunicipio === null || _selectedMunicipio === void 0 ? void 0 : (ref = _selectedMunicipio.concessionarias) === null || ref === void 0 ? void 0 : ref.map(function(concessionaria) {
            concessionariaOptions.push({
                id: concessionaria.id,
                name: concessionaria.attributes.nome,
                label: concessionaria.attributes.nome,
                value: concessionaria.id
            });
        });
        setConcessionariasMunicipio(concessionariaOptions);
        if (concessionariaOptions.length < 2) {
            var ref1;
            setSelectedConcessionaria(concessionariaOptions === null || concessionariaOptions === void 0 ? void 0 : concessionariaOptions[0]);
            findPlanosDescontos({
                concessionariaId: concessionariaOptions === null || concessionariaOptions === void 0 ? void 0 : (ref1 = concessionariaOptions[0]) === null || ref1 === void 0 ? void 0 : ref1.id
            }).then(function(_dataConfigOfertas) {
                var ref;
                setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                    dataConfigOfertas: _dataConfigOfertas
                }));
                configSimulacao({
                    setFormData: setFormData,
                    formData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                        dataConfigOfertas: _dataConfigOfertas
                    }),
                    concessionariaId: concessionariaOptions === null || concessionariaOptions === void 0 ? void 0 : (ref = concessionariaOptions[0]) === null || ref === void 0 ? void 0 : ref.id
                });
            });
        }
    };
    var handleConcessionariaChange = function(_selectedConcessionaria) {
        console.log({
            _selectedConcessionaria: _selectedConcessionaria
        });
        setSelectedConcessionaria(_selectedConcessionaria);
        findPlanosDescontos({
            concessionariaId: _selectedConcessionaria.id
        }).then(function(_dataConfigOfertas) {
            setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                dataConfigOfertas: _dataConfigOfertas
            }));
            configSimulacao({
                setFormData: setFormData,
                formData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                    dataConfigOfertas: _dataConfigOfertas
                }),
                concessionariaId: _selectedConcessionaria.id
            });
        });
    };
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: (FormNovaJornada_styles_module_default()).iconLoading,
                src: imgSplash,
                width: 150,
                height: 150
            })
        });
    }
    var formProps = props.isApp ? {
        onSubmit: onSubmit,
        className: (FormNovaJornada_styles_module_default()).form,
        onInvalid: hasInvalidInputs,
        method: "get"
    } : {
        className: (FormNovaJornada_styles_module_default()).form,
        onInvalid: hasInvalidInputs,
        action: "".concat("https://app.electy.com.br", "/form-dados-pessoais"),
        target: "_blank",
        method: "get"
    };
    var ref25, _owner, ref26, _texto_descricao_consumo;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formProps), {
            children: [
                props.extraFields.map(function(item) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        name: (ref25 = (ref = item.key) === null || ref === void 0 ? void 0 : ref.toLowerCase()) !== null && ref25 !== void 0 ? ref25 : item.key,
                        value: item.value
                    }, "INPUT__".concat(item.key));
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "hidden",
                    name: "representante",
                    value: (_owner = props.owner) !== null && _owner !== void 0 ? _owner : props.wl.campanha_default
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "hidden",
                    name: "full",
                    value: props.full ? "1" : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "mobile__h3 ".concat((FormNovaJornada_styles_module_default()).title),
                    children: "Calcule sua economia"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Select2/* default */.Z, {
                    id: "select",
                    name: "municipio",
                    required: true,
                    handleChange: handleMunicipioChange,
                    placeholder: "Cidades",
                    handleFindOptions: handleFindOptionsMunicipios
                }),
                concessionariasMunicipio.length > 1 ? //Select de Concessionarias
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Select2/* default */.Z, {
                    id: "concessionaria",
                    isSearchable: false,
                    name: "concessionaria",
                    required: true,
                    placeholder: "Selecione a Concession\xe1ria",
                    handleChange: handleConcessionariaChange,
                    options: concessionariasMunicipio
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "hidden",
                            name: "concessionaria",
                            value: concessionariasMunicipio === null || concessionariasMunicipio === void 0 ? void 0 : (ref7 = concessionariasMunicipio[0]) === null || ref7 === void 0 ? void 0 : ref7.id
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "hidden",
                            name: "concessionaria_sigagente",
                            value: concessionariasMunicipio === null || concessionariasMunicipio === void 0 ? void 0 : (ref8 = concessionariasMunicipio[0]) === null || ref8 === void 0 ? void 0 : ref8.sigagente
                        })
                    ]
                }),
                !oneOptionContractEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            className: "mobile__h5 ".concat((FormNovaJornada_styles_module_default())["title-select-type"]),
                            children: "Escolha uma op\xe7\xe3o:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: (FormNovaJornada_styles_module_default())["select-type"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonIcon/* default */.Z, {
                                    color: props.wl.Calculadora.cor_botao_select,
                                    hoverColor: props.wl.Calculadora.cor_hover_botao_icon,
                                    type: "button",
                                    // bgOnMouseLeave={"#fff"}
                                    "data-attr": "pf",
                                    onClick: function() {
                                        handleSelectTipoPessoa("pf");
                                        configSimulacao({
                                            setFormData: setFormData,
                                            formData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                                selectedTypeButton: {
                                                    pf: "selected",
                                                    pj: "",
                                                    selected: "pf"
                                                }
                                            }),
                                            concessionariaId: selectedConcessionaria === null || selectedConcessionaria === void 0 ? void 0 : selectedConcessionaria.id
                                        });
                                    },
                                    className: "".concat((FormNovaJornada_styles_module_default()).button, " ").concat(formData === null || formData === void 0 ? void 0 : (ref9 = formData.selectedTypeButton) === null || ref9 === void 0 ? void 0 : ref9.pf),
                                    wl: props.wl,
                                    // srcIcon="/images/busca-usinas/step-0/user.svg"
                                    svgTag: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconUser, {
                                        color: props.wl.Calculadora.cor_botao_select,
                                        wl: props.wl
                                    }),
                                    children: "Para sua casa"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonIcon/* default */.Z, {
                                    color: props.wl.Calculadora.cor_botao_select,
                                    hoverColor: props.wl.Calculadora.cor_hover_botao_icon,
                                    type: "button",
                                    "data-attr": "pj",
                                    // bgOnMouseLeave={"#fff"}
                                    onClick: function() {
                                        handleSelectTipoPessoa("pj");
                                        configSimulacao({
                                            setFormData: setFormData,
                                            formData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                                selectedTypeButton: {
                                                    pf: "",
                                                    pj: "selected",
                                                    selected: "pj"
                                                }
                                            }),
                                            concessionariaId: selectedConcessionaria === null || selectedConcessionaria === void 0 ? void 0 : selectedConcessionaria.id
                                        });
                                    },
                                    className: "".concat((FormNovaJornada_styles_module_default()).button, " ").concat(formData === null || formData === void 0 ? void 0 : (ref10 = formData.selectedTypeButton) === null || ref10 === void 0 ? void 0 : ref10.pj),
                                    // srcIcon="/images/busca-usinas/step-0/bag.svg"
                                    wl: props.wl,
                                    svgTag: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBusiness, {
                                        color: props.wl.Calculadora.cor_botao_select,
                                        wl: props.wl
                                    }),
                                    children: "Para seu neg\xf3cio"
                                })
                            ]
                        })
                    ]
                }),
                errorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "msg__error__icon__alert ".concat((FormNovaJornada_styles_module_default())["msg-error"]),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/icons/notifications/alert-cicle.svg"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "error",
                            children: errorMessage
                        })
                    ]
                }) : "",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "text",
                    id: "tipoConta",
                    name: "tipoConta",
                    defaultValue: (ref26 = formData === null || formData === void 0 ? void 0 : (ref11 = formData.selectedTypeButton) === null || ref11 === void 0 ? void 0 : ref11.selected) !== null && ref26 !== void 0 ? ref26 : "",
                    required: true,
                    style: {
                        display: "none"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "hidden",
                    name: "pessoaFisica",
                    defaultValue: (formData === null || formData === void 0 ? void 0 : (ref12 = formData.selectedTypeButton) === null || ref12 === void 0 ? void 0 : ref12.selected) === "pf" ? "Sim" : "N\xe3o"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "hidden",
                    name: "pessoaJuridica",
                    defaultValue: (formData === null || formData === void 0 ? void 0 : (ref13 = formData.selectedTypeButton) === null || ref13 === void 0 ? void 0 : ref13.selected) === "pj" ? "Sim" : "N\xe3o"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            className: "mobile__h5 ".concat((FormNovaJornada_styles_module_default()).h5),
                            children: (_texto_descricao_consumo = props.wl.Calculadora.texto_descricao_consumo) !== null && _texto_descricao_consumo !== void 0 ? _texto_descricao_consumo : "Quanto voc\xea gasta com luz por m\xeas?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mobile__p5 ".concat((FormNovaJornada_styles_module_default()).p5),
                            children: "Arraste at\xe9 atingir o valor da sua conta de luz ou digite o valor abaixo"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RangeMoney, {
                    name: "money",
                    wl: props.wl,
                    defaultValue: formData.valorConsumo,
                    max: 50000,
                    handleUpdateValue: function(newValue) {
                        setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                            valorConsumo: newValue
                        }));
                        configSimulacao({
                            setFormData: setFormData,
                            formData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                valorConsumo: newValue
                            }),
                            concessionariaId: selectedConcessionaria === null || selectedConcessionaria === void 0 ? void 0 : selectedConcessionaria.id
                        });
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "economiainfo",
                    children: !(formData === null || formData === void 0 ? void 0 : (ref14 = formData.dataDiscount) === null || ref14 === void 0 ? void 0 : ref14.status) ? getResultFailMessage(formData === null || formData === void 0 ? void 0 : (ref15 = formData.dataDiscount) === null || ref15 === void 0 ? void 0 : ref15.message) : getResultDiscountMessage(formData === null || formData === void 0 ? void 0 : (ref16 = formData.dataDiscount) === null || ref16 === void 0 ? void 0 : ref16.valorDescontoAnual, props === null || props === void 0 ? void 0 : (ref17 = props.wl) === null || ref17 === void 0 ? void 0 : ref17.cor_tema_primaria)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    name: submitButtonChildren,
                    isDisable: submitButtonChildren != "QUERO SABER MAIS" || !(formData === null || formData === void 0 ? void 0 : (ref18 = formData.dataDiscount) === null || ref18 === void 0 ? void 0 : ref18.status),
                    type: "submit",
                    style: bgSubmitButton,
                    wl: props.wl
                }),
                props.isApp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (FormNovaJornada_styles_module_default())["text-privacy-policy"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Ao prosseguir significa que voc\xea aceita nossos"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitleText/* default */.Z, {
                                            "src-icon-close": "/images/icons/button/close-white.svg",
                                            content: (0,lang/* lang */.K)("usuario/index.termos-uso", "")
                                        })
                                    }),
                                    " ",
                                    "e",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitleText/* default */.Z, {
                                            "src-icon-close": "/images/icons/button/close-white.svg",
                                            content: (0,lang/* lang */.K)("usuario/index.politica-privacidade", "")
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (FormNovaJornada_styles_module_default())["text-privacy-policy"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Ao prosseguir significa que voc\xea aceita os "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitleText/* default */.Z, {
                                            "src-icon-close": "/images/icons/button/close-white.svg",
                                            content: (0,lang/* lang */.K)("usuario/index.termos-uso", "")
                                        })
                                    }),
                                    "e",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitleText/* default */.Z, {
                                            "src-icon-close": "/images/icons/button/close-white.svg",
                                            content: (0,lang/* lang */.K)("usuario/index.politica-privacidade", "")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "da Electy"
                            })
                        ]
                    })
                })
            ]
        }))
    });
};
/* harmony default export */ var components_FormNovaJornada = (FormNovaJornada);

// EXTERNAL MODULE: ./src/pages/calculadora-desconto/components/Iframe/styles.module.css
var Iframe_styles_module = __webpack_require__(77212);
var Iframe_styles_module_default = /*#__PURE__*/__webpack_require__.n(Iframe_styles_module);
;// CONCATENATED MODULE: ./src/pages/calculadora-desconto/components/Iframe/configSimulacao.jsx









var configSimulacao_statusSimulacao = {
    empty_inputs: "empty_inputs",
    regiao_nao_atendida: "regiao_nao_atendida",
    sem_estoque: "sem_estoque",
    sem_consumo_minimo: "sem_consumo_minimo",
    tipo_pf_pj_indisponivel: "tipo_pf_pj_indisponivel",
    zero_value: "zero_value"
};
var configSimulacao_configSimulacao = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var formData, setFormData, concessionariaId, ref, ref1, ref2, ref3, ref4, ref5, ref6, _dataConfigOfertas, mlRules, planoUsinasConcessionarias, planoUsinasDisponiveis, dataMercadoLivre, planoUsinasDisponiveisTipoPfPj, planoUsinasContrataveis, melhorContratoPlanoUsina, valorDesconto;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    formData = param.formData, setFormData = param.setFormData, concessionariaId = param.concessionariaId;
                    if ((formData === null || formData === void 0 ? void 0 : formData.valorConsumo) == 0) {
                        return [
                            2,
                            setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                dataDiscount: configSimulacao_dataDescontoFail(configSimulacao_statusSimulacao.zero_value)
                            }))
                        ];
                    }
                    if (!(formData === null || formData === void 0 ? void 0 : (ref = formData.selectedTypeButton) === null || ref === void 0 ? void 0 : ref.selected) || !formData.valorConsumo || !(formData === null || formData === void 0 ? void 0 : formData.dataConfigOfertas)) {
                        return [
                            2,
                            setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                dataDiscount: configSimulacao_dataDescontoFail(configSimulacao_statusSimulacao.empty_inputs)
                            }))
                        ];
                    }
                    _dataConfigOfertas = formData.dataConfigOfertas, mlRules = _dataConfigOfertas.mlRules, planoUsinasConcessionarias = _dataConfigOfertas.planoUsinasConcessionarias, planoUsinasDisponiveis = _dataConfigOfertas.planoUsinasDisponiveis;
                    return [
                        4,
                        getDataDescontoElegivelMercadoLivre({
                            tipoConta: formData === null || formData === void 0 ? void 0 : (ref1 = formData.selectedTypeButton) === null || ref1 === void 0 ? void 0 : ref1.selected,
                            consumoDinheiro: formData.valorConsumo,
                            info: mlRules
                        })
                    ];
                case 1:
                    dataMercadoLivre = _state.sent();
                    if (dataMercadoLivre.elegivel) {
                        return [
                            2,
                            setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                dataDiscount: configSimulacao_dataDescontoOk(dataMercadoLivre.valorDesconto)
                            }))
                        ];
                    }
                    if (!configSimulacao_isRegiaoAtendida({
                        planoUsinasConcessionarias: planoUsinasConcessionarias
                    })) {
                        return [
                            2,
                            setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                dataDiscount: configSimulacao_dataDescontoFail(configSimulacao_statusSimulacao.regiao_nao_atendida)
                            }))
                        ];
                    }
                    if (!configSimulacao_hasStock({
                        planoUsinasDisponiveis: planoUsinasDisponiveis
                    })) {
                        return [
                            2,
                            setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                dataDiscount: configSimulacao_dataDescontoFail(configSimulacao_statusSimulacao.sem_estoque)
                            }))
                        ];
                    }
                    return [
                        4,
                        filtrarPlanoUsinasDisponiveisTipoPfPj({
                            planoUsinas: planoUsinasDisponiveis,
                            tipoConta: formData === null || formData === void 0 ? void 0 : (ref2 = formData.selectedTypeButton) === null || ref2 === void 0 ? void 0 : ref2.selected
                        })
                    ];
                case 2:
                    planoUsinasDisponiveisTipoPfPj = _state.sent();
                    if (planoUsinasDisponiveisTipoPfPj.length === 0) {
                        return [
                            2,
                            setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                dataDiscount: configSimulacao_dataDescontoFail(configSimulacao_statusSimulacao.tipo_pf_pj_indisponivel)
                            }))
                        ];
                    }
                    return [
                        4,
                        filtrarPlanoUsinasContrataveis({
                            planoUsinas: planoUsinasDisponiveisTipoPfPj,
                            consumoDinheiro: formData.valorConsumo,
                            concessionariaId: concessionariaId,
                            tipoConta: formData === null || formData === void 0 ? void 0 : (ref3 = formData.selectedTypeButton) === null || ref3 === void 0 ? void 0 : ref3.selected
                        })
                    ];
                case 3:
                    planoUsinasContrataveis = _state.sent();
                    if (planoUsinasContrataveis.length == 0) {
                        return [
                            2,
                            setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                dataDiscount: configSimulacao_dataDescontoFail(configSimulacao_statusSimulacao.sem_consumo_minimo)
                            }))
                        ];
                    }
                    return [
                        4,
                        filtrarMelhorContratoPlanoUsina({
                            planoUsinas: planoUsinasContrataveis,
                            tipoConta: formData === null || formData === void 0 ? void 0 : (ref4 = formData.selectedTypeButton) === null || ref4 === void 0 ? void 0 : ref4.selected
                        })
                    ];
                case 4:
                    melhorContratoPlanoUsina = _state.sent();
                    valorDesconto = calcularValorDescontoAnual({
                        porcentagem: (ref6 = melhorContratoPlanoUsina.attributes) === null || ref6 === void 0 ? void 0 : ref6["desconto_porcentagem_".concat(formData === null || formData === void 0 ? void 0 : (ref5 = formData.selectedTypeButton) === null || ref5 === void 0 ? void 0 : ref5.selected)],
                        consumoDinheiro: parseInt(formData.valorConsumo)
                    });
                    // if (valorDesconto <= 0) {
                    //   return setFormData({
                    //     ...formData,
                    //     dataDiscount: dataDescontoFail(statusSimulacao.sem_consumo_minimo),
                    //   });
                    // }
                    setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                        dataDiscount: configSimulacao_dataDescontoOk(valorDesconto)
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return function configSimulacao(_) {
        return _ref.apply(this, arguments);
    };
}();
function configSimulacao_isRegiaoAtendida(param) {
    var planoUsinasConcessionarias = param.planoUsinasConcessionarias;
    if (!planoUsinasConcessionarias) {
        return false;
    }
    if (planoUsinasConcessionarias.length == 0) {
        return false;
    }
    return true;
}
function configSimulacao_hasStock(param) {
    var planoUsinasDisponiveis = param.planoUsinasDisponiveis;
    if (!planoUsinasDisponiveis) {
        return false;
    }
    if (planoUsinasDisponiveis.length == 0) {
        return false;
    }
    return true;
}
function configSimulacao_dataDescontoFail(message) {
    return {
        status: false,
        message: message
    };
}
function configSimulacao_dataDescontoOk(valorDescontoAnual) {
    return {
        status: true,
        valorDescontoAnual: Math.round(valorDescontoAnual)
    };
}

;// CONCATENATED MODULE: ./src/pages/calculadora-desconto/components/Iframe/findPlanosDescontos.jsx

function findPlanosDescontos_findPlanosDescontos(param) {
    var concessionariaId = param.concessionariaId;
    return axios_default().post("/api/simulacao", {
        concessionariaId: concessionariaId
    }).then(function(data) {
        return data.data;
    }).catch(function() {
        return [];
    });
}

;// CONCATENATED MODULE: ./src/pages/calculadora-desconto/components/Iframe/getResultMessages.jsx



function getResultMessages_getResultDiscountMessage(value, corTema) {
    return /*#__PURE__*/ _jsxs("span", {
        className: styles.msgDiscount,
        children: [
            "Voc\xea pode economizar at\xe9 ",
            " ",
            /*#__PURE__*/ _jsx("strong", {
                style: {
                    color: corTema
                },
                children: parseFloat(value).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL"
                })
            }),
            " ",
            " ",
            "por ano"
        ]
    });
}
function getResultMessages_getResultFailMessage(status) {
    var messages = {};
    messages[configSimulacao_statusSimulacao.empty_inputs] = "";
    messages[configSimulacao_statusSimulacao.regiao_nao_atendida] = "Regi\xe3o n\xe3o atendida no momento";
    messages[configSimulacao_statusSimulacao.sem_consumo_minimo] = "Consumo insuficiente para obter descontos";
    messages[configSimulacao_statusSimulacao.sem_estoque] = "Regi\xe3o sem estoque dispon\xedvel";
    messages[configSimulacao_statusSimulacao.tipo_pf_pj_indisponivel] = "Tipo de contrata\xe7\xe3o n\xe3o dispon\xedvel no momento";
    messages[configSimulacao_statusSimulacao.zero_value] = "Consumo insuficiente para obter descontos";
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (Iframe_styles_module_default()).msgDiscountError,
        children: (ref = messages === null || messages === void 0 ? void 0 : messages[status]) !== null && ref !== void 0 ? ref : ""
    });
}

// EXTERNAL MODULE: ./src/components/ToggleButtons/styles.module.css
var ToggleButtons_styles_module = __webpack_require__(8751);
var ToggleButtons_styles_module_default = /*#__PURE__*/__webpack_require__.n(ToggleButtons_styles_module);
;// CONCATENATED MODULE: ./src/components/ToggleButtons/index.jsx



function ToggleButtons(param) {
    var txtButton1 = param.txtButton1, txtButton2 = param.txtButton2, valueButton1 = param.valueButton1, valueButton2 = param.valueButton2, handleSelect = param.handleSelect, wl = param.wl;
    var ref = (0,react.useState)(valueButton1), selected = ref[0], setSelected = ref[1];
    var handleSelectTypePerson = function(type) {
        setSelected(type);
        handleSelect(type);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ToggleButtons_styles_module_default())["toggle-buttons"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "".concat((ToggleButtons_styles_module_default()).btn, " ").concat(selected === valueButton1 ? (ToggleButtons_styles_module_default()).active : ""),
                style: {
                    background: selected === valueButton1 ? wl.cor_tema_primaria : "#DDE1E7",
                    color: selected === valueButton1 ? "#FFF" : "#000"
                },
                onClick: function() {
                    return handleSelectTypePerson(valueButton1);
                },
                children: txtButton1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "".concat((ToggleButtons_styles_module_default()).btn, "  ").concat(selected === valueButton2 ? "".concat((ToggleButtons_styles_module_default()).active, " ").concat((ToggleButtons_styles_module_default()).alt) : (ToggleButtons_styles_module_default()).alt),
                style: {
                    background: selected === valueButton2 ? wl.cor_tema_primaria : "#DDE1E7",
                    color: selected === valueButton2 ? "#FFF" : "#000"
                },
                onClick: function() {
                    return handleSelectTypePerson(valueButton2);
                },
                children: txtButton2
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/components/Input/InputCard/styles.module.css
var InputCard_styles_module = __webpack_require__(53522);
var InputCard_styles_module_default = /*#__PURE__*/__webpack_require__.n(InputCard_styles_module);
;// CONCATENATED MODULE: ./src/components/Input/InputCard/index.jsx







function InputCard(_param) {
    var key = _param.key, title = _param.title, placeholder = _param.placeholder, component = _param.component, alturaMenuOpen = _param.alturaMenuOpen, value = _param.value, wl = _param.wl, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "key",
        "title",
        "placeholder",
        "component",
        "alturaMenuOpen",
        "value",
        "wl"
    ]);
    // Se o valor vier como "R$ 123,45", separe o cifrão do valor
    var symbol = "";
    var money = value;
    if (typeof value === "string" && value.trim().startsWith("R$")) {
        var ref;
        ref = (0,_sliced_to_array/* default */.Z)(value.split(/\s(.+)/), 2), symbol = ref[0], money = ref[1], ref; // separa "R$" e o resto
    }
    var corTema = (wl === null || wl === void 0 ? void 0 : wl.cor_tema_primaria) || "gray";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (InputCard_styles_module_default())["input-card"],
        style: {
            height: 70 + alturaMenuOpen
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: title,
                children: title
            }),
            component ? /*#__PURE__*/ react.cloneElement(component, (0,_object_spread/* default */.Z)({
                name: name
            }, restProps)) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (InputCard_styles_module_default()).moneyInputWrapper,
                children: [
                    symbol && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (InputCard_styles_module_default()).cifrao,
                        children: symbol
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        type: "text",
                        id: title,
                        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
                        value: money
                    }, restProps), {
                        className: (InputCard_styles_module_default()).moneyInput,
                        style: {
                            color: corTema
                        }
                    }))
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react-select/dist/index-641ee5b8.esm.js + 4 modules
var index_641ee5b8_esm = __webpack_require__(45350);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 10 modules
var react_select_esm = __webpack_require__(75217);
// EXTERNAL MODULE: ./src/components/Select/SelectUnstyled/styles.module.css
var SelectUnstyled_styles_module = __webpack_require__(59938);
var SelectUnstyled_styles_module_default = /*#__PURE__*/__webpack_require__.n(SelectUnstyled_styles_module);
;// CONCATENATED MODULE: ./src/components/Select/SelectUnstyled/src/find-options-effect.js


var useFindOptionsEffect = function(searchValue, handleFindOptions, setOptions, setLoading, nomeCampo) {
    (0,react.useEffect)(function() {
        if ((searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) > 2) {
            setLoading(true);
            var timer = setTimeout(function() {
                if (handleFindOptions) {
                    handleFindOptions(searchValue).then(function(resultOptions) {
                        (0,lib.setCookie)("electy-server@".concat(nomeCampo), resultOptions);
                        setOptions(resultOptions);
                    }).catch(function(err) {
                        setOptions([]);
                    }).finally(function() {
                        setLoading(false);
                    });
                }
            }, 1000);
            return function() {
                setLoading(false);
                clearTimeout(timer);
            };
        }
    }, [
        searchValue
    ]);
};

;// CONCATENATED MODULE: ./src/components/Select/SelectUnstyled/index.jsx











var groupStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "#D9D9D980",
    color: "var(--black-400)",
    fontWeight: "bold",
    textTransform: "capitalize"
};
var formatGroupLabel = function(data) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: groupStyles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: data.label
        })
    });
};
/**
 * Componente que utiliza lib Select2
 *
 * @param {onFocus} param0
 * @returns
 */ var SelectUnstyled = function(_param) {
    var id = _param.id, name = _param.name, onFocus = _param.onFocus, onBlur = _param.onBlur, handleChange = _param.handleChange, style = _param.style, handleFindOptions = _param.handleFindOptions, noOptionsMessage = _param.noOptionsMessage, className = _param.className, wl = _param.wl, key = _param.key, handleMenuOpen = _param.handleMenuOpen, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "name",
        "onFocus",
        "onBlur",
        "handleChange",
        "style",
        "handleFindOptions",
        "noOptionsMessage",
        "className",
        "wl",
        "key",
        "handleMenuOpen"
    ]);
    var ref;
    var ref1 = (0,react.useState)({}), styleFocus = ref1[0], setStyleFocus = ref1[1];
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var _options;
    var ref3 = (0,react.useState)((_options = restProps.options) !== null && _options !== void 0 ? _options : []), options = ref3[0], setOptions = ref3[1];
    var ref4 = (0,react.useState)(""), searchValue = ref4[0], setSearchValue = ref4[1];
    var ref5 = (0,react.useState)({
        width: 0,
        height: 0
    }), menuSize = ref5[0], setMenuSize = ref5[1];
    var uniqueId = id || "select-".concat(Math.random().toString(36).substr(2, 9));
    useFindOptionsEffect(searchValue, handleFindOptions, setOptions, setLoading, name);
    var handleInputChange = function(inputValue, param) {
        var action = param.action;
        if (action === "input-change") {
            setSearchValue(inputValue);
        }
    };
    var ref6, ref7, ref8, ref9, ref10;
    // const handleChangeOpcaoSelecionada   = (opcaoSelecionada) => {
    //   setValue(opcaoSelecionada?.label);
    //   handleChange(opcaoSelecionada);
    // }
    var customStyles = (0,_define_property/* default */.Z)({
        control: function(base) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                border: "none",
                boxShadow: "none",
                backgroundColor: "transparent",
                minHeight: "20px"
            });
        },
        menu: function(base) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                with: "100%",
                top: "100%",
                left: 0,
                width: "100%",
                borderRadius: "0 0 8px 8px",
                border: "1px solid #ccc",
                borderTop: "none",
                zIndex: 10,
                // background: 'red',
                margin: "0"
            });
        },
        // indicatorSeparator: () => ({
        //   display: "none",
        // }),
        // indicatorsContainer: () => ({
        //   display: "none",
        // }),
        clearIndicator: function(base) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                // backgroundColor: wl?.cor_tema_3, // vermelho claro
                color: (ref6 = wl === null || wl === void 0 ? void 0 : wl.cor_tema_primaria) !== null && ref6 !== void 0 ? ref6 : "#e0e0e0",
                padding: 0,
                // borderRadius: "4px",
                margin: 0,
                cursor: "pointer"
            });
        },
        group: function(base) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                paddingTop: 0,
                paddingBottom: 0
            });
        },
        singleValue: function(base) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                fontSize: "16px",
                color: (ref7 = wl === null || wl === void 0 ? void 0 : wl.cor_tema_primaria) !== null && ref7 !== void 0 ? ref7 : "gray",
                fontWeight: 700,
                margin: 0,
                padding: 0,
                heigth: "10px"
            });
        },
        indicatorSeparator: function(base) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                display: "none"
            });
        },
        dropdownIndicator: function(base) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                display: "none"
            });
        },
        loadingIndicator: function(base) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                color: (ref8 = wl === null || wl === void 0 ? void 0 : wl.cor_tema_3) !== null && ref8 !== void 0 ? ref8 : "#e0e0e0"
            });
        },
        valueContainer: function(provided) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                padding: 0
            });
        },
        input: function(base) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                padding: 0,
                margin: 0,
                color: (ref9 = wl === null || wl === void 0 ? void 0 : wl.cor_tema_primaria) !== null && ref9 !== void 0 ? ref9 : "gray",
                fontWeight: 700,
                fontSize: "16px"
            });
        },
        placeholder: function(base) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                color: "#929CA8",
                fontSize: "14px",
                margin: 0,
                padding: 0
            });
        },
        groupHeading: function(base) {
            return {
                //   display: 'none',   // remove o espaço do heading
                padding: 0,
                marginTop: 10,
                marginBottom: 5
            };
        },
        menuList: function(base) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                paddingTop: 0,
                paddingBottom: 0,
                margin: "20px",
                scrollbarWidth: "thin",
                scrollbarColor: "red #f1f1f1",
                maxHeight: 200
            });
        },
        option: function(base, state) {
            return {
                backgroundColor: state.isFocused ? (ref10 = wl === null || wl === void 0 ? void 0 : wl.cor_tema_3) !== null && ref10 !== void 0 ? ref10 : "#e0e0e0" // Cor dos itens selecionados ao passar do mouse
                 : (wl === null || wl === void 0 ? void 0 : wl.cor_tema_primaria) ? "#fff" : "#fff",
                // color: state.isSelected ? "#000" ?? "#fff" : "#000",
                color: "#929CA8",
                marginBottom: "7px",
                padding: 0,
                cursor: "pointer"
            };
        }
    }, "menuList", function(base) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
            padding: 0,
            border: "1px solid #DDE1E7",
            borderRadius: "8px",
            maxHeight: 200
        });
    });
    var handleMenuActivation = function() {
        setTimeout(function() {
            var menu = document.querySelector(".custom-scroll__menu");
            if (menu) {
                var height = menu.getBoundingClientRect().height;
                if (height > 10) {
                    handleMenuOpen(height, "open");
                }
            }
        }, 80);
    };
    var focus = function(event) {
        handleMenuActivation();
        if (onFocus) {
            onFocus(event);
        }
        setStyleFocus({
            border: "1px solid red !important",
            boxShadow: "0 0 0.5rem red !important",
            outline: 0
        });
    };
    var blur = function(event) {
        if (onBlur) {
            onBlur(event);
        }
        setStyleFocus({});
    };
    // const customComponents = {
    //   GroupHeading: () => null, // <- remove a tarja do estado
    // };
    var customLoadingMessage = function() {
        return "Carregando...";
    };
    // Função para personalizar a mensagem quando não há opções
    var handleNoOptionsMessage = function(param) {
        var inputValue = param.inputValue;
        return inputValue ? "N\xe3o encontrado" : "Digite para buscar op\xe7\xf5es";
    };
    // Custom Menu para adicionar data-select-id
    var CustomMenu = function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_641ee5b8_esm.c.Menu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            innerProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.innerProps), {
                "data-select-id": uniqueId
            })
        }));
    };
    (0,react.useEffect)(function() {
        var observer = new MutationObserver(function() {
            var menu = document.querySelector('.custom-scroll__menu[data-select-id="'.concat(uniqueId, '"]'));
            if (menu) {
                var height = menu.getBoundingClientRect().height;
                handleMenuOpen(height, "open");
            } else {
                handleMenuOpen(0, "close");
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        return function() {
            return observer.disconnect();
        };
    }, [
        handleMenuOpen,
        uniqueId
    ]);
    var ref11, _required, _isClearable, _isSearchable, _isDisabled, _isLoading, _isRtl, ref12;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, (0,_object_spread/* default */.Z)({
            id: restProps.id,
            styles: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, customStyles, styleFocus, style), {
                menuList: function(base) {
                    var _obj;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), (_obj = {
                        maxHeight: 200,
                        overflowY: "auto"
                    }, (0,_define_property/* default */.Z)(_obj, "maxHeight", 200), /* Aqui você injeta o estilo no próprio elemento */ (0,_define_property/* default */.Z)(_obj, "scrollbarWidth", "thin"), (0,_define_property/* default */.Z)(_obj, "scrollbarColor", "".concat((ref11 = wl === null || wl === void 0 ? void 0 : wl.cor_tema_primaria) !== null && ref11 !== void 0 ? ref11 : "gray", " #f1f1f1")), _obj));
                }
            }),
            className: "".concat((SelectUnstyled_styles_module_default()).select, " ").concat(className),
            classNamePrefix: "custom-scroll",
            components: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps.components), {
                Menu: CustomMenu
            }),
            options: options,
            onFocus: focus,
            onBlur: blur,
            required: (_required = restProps.required) !== null && _required !== void 0 ? _required : false,
            isClearable: (_isClearable = restProps.isClearable) !== null && _isClearable !== void 0 ? _isClearable : true,
            isSearchable: (_isSearchable = restProps.isSearchable) !== null && _isSearchable !== void 0 ? _isSearchable : true,
            isDisabled: (_isDisabled = restProps.isDisabled) !== null && _isDisabled !== void 0 ? _isDisabled : false,
            isLoading: (_isLoading = restProps.isLoading) !== null && _isLoading !== void 0 ? _isLoading : loading,
            loadingMessage: customLoadingMessage,
            isRtl: (_isRtl = restProps.isRtl) !== null && _isRtl !== void 0 ? _isRtl : false,
            name: name !== null && name !== void 0 ? name : "select",
            onInputChange: handleInputChange,
            onChange: handleChange,
            onClick: handleMenuActivation,
            formatGroupLabel: formatGroupLabel,
            noOptionsMessage: handleNoOptionsMessage,
            placeholder: restProps.placeholder ? restProps.placeholder : "Selecione uma op\xe7\xe3o",
            defaultValue: (ref12 = restProps === null || restProps === void 0 ? void 0 : (ref = restProps.options) === null || ref === void 0 ? void 0 : ref.filter(function(option) {
                return (option === null || option === void 0 ? void 0 : option.label) === (restProps === null || restProps === void 0 ? void 0 : restProps.defaultValue);
            })) !== null && ref12 !== void 0 ? ref12 : [],
            onKeyDown: function() {
                setTimeout(function() {
                    var menu = document.querySelector(".custom-scroll__menu");
                    if (menu) {
                        var height = menu.getBoundingClientRect().height;
                        // Garantir que a altura é válida
                        if (height > 10) {
                            handleMenuOpen(height, "open");
                        } else {
                            console.warn("⚠️ Altura muito baixa ou menu ainda animando.");
                        }
                    } else {
                        console.warn("❌ Menu n\xe3o encontrado no DOM.");
                    }
                }, 10); // delay suficiente para o menu renderizar
            },
            menuPosition: "absolute",
            onMenuClose: function() {
                var menu = document.querySelector(".custom-scroll__menu");
                if (menu) {
                    var ref = menu.getBoundingClientRect(), width = ref.width, height = ref.height;
                    handleMenuOpen(height, "close");
                } else {
                // console.log("❌ On menu close : Menu não encontrado");
                }
            }
        }, restProps), key)
    });
};
/* harmony default export */ var Select_SelectUnstyled = (SelectUnstyled);

// EXTERNAL MODULE: ./src/functions/mask.jsx
var mask = __webpack_require__(3938);
;// CONCATENATED MODULE: ./src/components/Icon/IconCo2/index.jsx


function IconCo2(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "46",
        height: "46",
        viewBox: "0 0 46 46",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.8642 2.47254C21.8929 1.20002 23.8329 1.20002 24.8616 2.47253L27.1105 5.25455C27.7496 6.04519 28.7947 6.38476 29.7765 6.12079L33.2311 5.19194C34.8112 4.76708 36.3808 5.90744 36.465 7.54155L36.6492 11.1141C36.7015 12.1294 37.3474 13.0184 38.2969 13.3819L41.6377 14.6611C43.1658 15.2461 43.7653 17.0913 42.8729 18.4628L40.922 21.4613C40.3676 22.3135 40.3676 23.4123 40.922 24.2645L42.8729 27.263C43.7653 28.6345 43.1658 30.4797 41.6377 31.0647L38.2969 32.3439C37.3474 32.7074 36.7015 33.5964 36.6492 34.6117L36.465 38.1842C36.3808 39.8184 34.8112 40.9587 33.2311 40.5339L29.7765 39.605C28.7947 39.341 27.7496 39.6806 27.1105 40.4713L24.8616 43.2533C23.8329 44.5258 21.8929 44.5258 20.8642 43.2533L18.6153 40.4713C17.9762 39.6806 16.9311 39.341 15.9493 39.605L12.4947 40.5339C10.9146 40.9587 9.34499 39.8184 9.26077 38.1842L9.07662 34.6117C9.02429 33.5964 8.37837 32.7074 7.42893 32.3439L4.08814 31.0647C2.56004 30.4797 1.96052 28.6345 2.85288 27.263L4.80379 24.2645C5.35824 23.4123 5.35824 22.3135 4.8038 21.4613L2.85288 18.4628C1.96052 17.0913 2.56004 15.2461 4.08814 14.6611L7.42893 13.3819C8.37837 13.0184 9.02429 12.1294 9.07662 11.1141L9.26077 7.54155C9.34499 5.90744 10.9146 4.76708 12.4947 5.19194L15.9493 6.12079C16.9311 6.38476 17.9762 6.04519 18.6153 5.25455L20.8642 2.47254Z",
                fill: "#26A150"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.1133 31.2686H28.1133V27.2686H29.1133V31.2686ZM18.1133 29.2686H17.1133V25.2686H18.1133V29.2686ZM22.1875 18.8525H19.0625L23.9053 23.8662L26.8164 20.8535H23.6914L28.3789 16.001L33.0664 20.8535H29.9414L35.8789 27.001H20.8789L22.8115 25H10L15.9375 18.8525H12.8125L17.5 14L22.1875 18.8525Z",
                fill: "#B7D943"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.1133 31.2686V31.8686H29.7133V31.2686H29.1133ZM28.1133 31.2686H27.5133V31.8686H28.1133V31.2686ZM28.1133 27.2686V26.6686H27.5133V27.2686H28.1133ZM29.1133 27.2686H29.7133V26.6686H29.1133V27.2686ZM18.1133 29.2686V29.8686H18.7133V29.2686H18.1133ZM17.1133 29.2686H16.5133V29.8686H17.1133V29.2686ZM17.1133 25.2686V24.6686H16.5133V25.2686H17.1133ZM18.1133 25.2686H18.7133V24.6686H18.1133V25.2686ZM22.1875 18.8525V19.4525H23.6013L22.619 18.4357L22.1875 18.8525ZM19.0625 18.8525V18.2525H17.6488L18.6309 19.2694L19.0625 18.8525ZM23.9053 23.8662L23.4737 24.2831L23.9052 24.7298L24.3367 24.2831L23.9053 23.8662ZM26.8164 20.8535L27.2479 21.2704L28.2305 20.2535H26.8164V20.8535ZM23.6914 20.8535L23.2599 20.4367L22.2776 21.4535H23.6914V20.8535ZM28.3789 16.001L28.8104 15.5841L28.3789 15.1374L27.9474 15.5841L28.3789 16.001ZM33.0664 20.8535V21.4535H34.4802L33.4979 20.4367L33.0664 20.8535ZM29.9414 20.8535V20.2535H28.5277L29.5098 21.2703L29.9414 20.8535ZM35.8789 27.001V27.601H37.2926L36.3105 26.5841L35.8789 27.001ZM20.8789 27.001L20.4473 26.5841L19.4652 27.601H20.8789V27.001ZM22.8115 25L23.2431 25.4168L24.2252 24.4H22.8115V25ZM10 25L9.56843 24.5832L8.58633 25.6H10V25ZM15.9375 18.8525L16.3691 19.2694L17.3512 18.2525H15.9375V18.8525ZM12.8125 18.8525L12.381 18.4357L11.3987 19.4525H12.8125V18.8525ZM17.5 14L17.9315 13.5831L17.5 13.1364L17.0685 13.5831L17.5 14ZM29.1133 31.2686V30.6686H28.1133V31.2686V31.8686H29.1133V31.2686ZM28.1133 31.2686H28.7133V27.2686H28.1133H27.5133V31.2686H28.1133ZM28.1133 27.2686V27.8686H29.1133V27.2686V26.6686H28.1133V27.2686ZM29.1133 27.2686H28.5133V31.2686H29.1133H29.7133V27.2686H29.1133ZM18.1133 29.2686V28.6686H17.1133V29.2686V29.8686H18.1133V29.2686ZM17.1133 29.2686H17.7133V25.2686H17.1133H16.5133V29.2686H17.1133ZM17.1133 25.2686V25.8686H18.1133V25.2686V24.6686H17.1133V25.2686ZM18.1133 25.2686H17.5133V29.2686H18.1133H18.7133V25.2686H18.1133ZM22.1875 18.8525V18.2525H19.0625V18.8525V19.4525H22.1875V18.8525ZM19.0625 18.8525L18.6309 19.2694L23.4737 24.2831L23.9053 23.8662L24.3368 23.4494L19.4941 18.4357L19.0625 18.8525ZM23.9053 23.8662L24.3367 24.2831L27.2479 21.2704L26.8164 20.8535L26.3849 20.4366L23.4738 23.4493L23.9053 23.8662ZM26.8164 20.8535V20.2535H23.6914V20.8535V21.4535H26.8164V20.8535ZM23.6914 20.8535L24.1229 21.2704L28.8104 16.4178L28.3789 16.001L27.9474 15.5841L23.2599 20.4367L23.6914 20.8535ZM28.3789 16.001L27.9474 16.4178L32.6349 21.2704L33.0664 20.8535L33.4979 20.4367L28.8104 15.5841L28.3789 16.001ZM33.0664 20.8535V20.2535H29.9414V20.8535V21.4535H33.0664V20.8535ZM29.9414 20.8535L29.5098 21.2703L35.4473 27.4178L35.8789 27.001L36.3105 26.5841L30.373 20.4367L29.9414 20.8535ZM35.8789 27.001V26.401H20.8789V27.001V27.601H35.8789V27.001ZM20.8789 27.001L21.3105 27.4178L23.2431 25.4168L22.8115 25L22.38 24.5832L20.4473 26.5841L20.8789 27.001ZM22.8115 25V24.4H10V25V25.6H22.8115V25ZM10 25L10.4316 25.4168L16.3691 19.2694L15.9375 18.8525L15.5059 18.4357L9.56843 24.5832L10 25ZM15.9375 18.8525V18.2525H12.8125V18.8525V19.4525H15.9375V18.8525ZM12.8125 18.8525L13.244 19.2694L17.9315 14.4169L17.5 14L17.0685 13.5831L12.381 18.4357L12.8125 18.8525ZM17.5 14L17.0685 14.4169L21.756 19.2694L22.1875 18.8525L22.619 18.4357L17.9315 13.5831L17.5 14Z",
                fill: "#1A1A1A"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Icon/IconPercent/index.jsx


function IconPercent(props) {
    var ref = (props === null || props === void 0 ? void 0 : props.wl) || {}, cor_tema_primaria = ref.cor_tema_primaria, cor_tema_3 = ref.cor_tema_3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "46",
        height: "46",
        viewBox: "0 0 46 46",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.8642 2.47254C21.8929 1.20002 23.8329 1.20002 24.8616 2.47253L27.1105 5.25455C27.7496 6.04519 28.7947 6.38476 29.7765 6.12079L33.2311 5.19194C34.8112 4.76708 36.3808 5.90744 36.465 7.54155L36.6492 11.1141C36.7015 12.1294 37.3474 13.0184 38.2969 13.3819L41.6377 14.6611C43.1658 15.2461 43.7653 17.0913 42.8729 18.4628L40.922 21.4613C40.3676 22.3135 40.3676 23.4123 40.922 24.2645L42.8729 27.263C43.7653 28.6345 43.1658 30.4797 41.6377 31.0647L38.2969 32.3439C37.3474 32.7074 36.7015 33.5964 36.6492 34.6117L36.465 38.1842C36.3808 39.8184 34.8112 40.9587 33.2311 40.5339L29.7765 39.605C28.7947 39.341 27.7496 39.6806 27.1105 40.4713L24.8616 43.2533C23.8329 44.5258 21.8929 44.5258 20.8642 43.2533L18.6153 40.4713C17.9762 39.6806 16.9311 39.341 15.9493 39.605L12.4947 40.5339C10.9146 40.9587 9.34499 39.8184 9.26077 38.1842L9.07662 34.6117C9.02429 33.5964 8.37837 32.7074 7.42893 32.3439L4.08814 31.0647C2.56004 30.4797 1.96052 28.6345 2.85288 27.263L4.80379 24.2645C5.35824 23.4123 5.35824 22.3135 4.8038 21.4613L2.85288 18.4628C1.96052 17.0913 2.56004 15.2461 4.08814 14.6611L7.42893 13.3819C8.37837 13.0184 9.02429 12.1294 9.07662 11.1141L9.26077 7.54155C9.34499 5.90744 10.9146 4.76708 12.4947 5.19194L15.9493 6.12079C16.9311 6.38476 17.9762 6.04519 18.6153 5.25455L20.8642 2.47254Z",
                fill: "#26A150"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.7568 14.5625L29.3242 15.9814L29.7803 16.2334L29.5088 16.6797L20.0127 32.2598L19.7578 32.6787L19.334 32.4326L16.8135 30.9668L16.373 30.7109L16.6377 30.2744L26.0879 14.7402L26.3369 14.3301L26.7568 14.5625ZM29.9854 22.4053C31.2869 22.4053 32.3839 22.8441 33.2324 23.7363L33.3867 23.9043C34.135 24.7609 34.5 25.8275 34.5 27.0693C34.5 28.3776 34.0837 29.4973 33.2354 30.3906L33.2334 30.3926C32.3795 31.2845 31.2828 31.7246 29.9854 31.7246C28.7036 31.7246 27.6148 31.2825 26.7568 30.3936L26.7539 30.3906C25.9054 29.4972 25.4883 28.3777 25.4883 27.0693C25.4883 25.7502 25.9041 24.6261 26.7549 23.7373L26.7559 23.7363H26.7568C27.6148 22.8473 28.7036 22.4053 29.9854 22.4053ZM29.9854 25.8447C29.714 25.8447 29.5428 25.9343 29.4131 26.1064L29.4141 26.1074C29.2747 26.2943 29.1748 26.5953 29.1748 27.0693C29.1748 27.54 29.2734 27.8402 29.4111 28.0273C29.5294 28.1826 29.6966 28.2764 29.9854 28.2764C30.2918 28.2763 30.4618 28.1787 30.5771 28.0273L30.5781 28.0264C30.7209 27.8401 30.8232 27.5411 30.8232 27.0693C30.8232 26.5898 30.7202 26.2879 30.5781 26.1025L30.5742 26.0977C30.4574 25.9412 30.2877 25.8448 29.9854 25.8447ZM16.0146 15.1367C17.3055 15.1367 18.398 15.5763 19.251 16.4658L19.4072 16.6338C20.161 17.4894 20.5292 18.5533 20.5293 19.791C20.5293 21.1006 20.1091 22.2211 19.2539 23.1143C18.3958 24.0105 17.3029 24.4561 16.0146 24.4561C14.7317 24.456 13.6396 24.0105 12.7764 23.1162L12.7744 23.1133C11.921 22.215 11.5 21.0952 11.5 19.791C11.5001 18.4709 11.9196 17.3487 12.7783 16.4658C13.6418 15.5781 14.733 15.1368 16.0146 15.1367ZM16.0146 18.5664C15.7437 18.5664 15.573 18.6563 15.4434 18.8281L15.4443 18.8291C15.3049 19.0159 15.2042 19.3169 15.2041 19.791C15.2041 20.2642 15.3044 20.565 15.4434 20.752C15.5713 20.917 15.7409 21.0068 16.0146 21.0068C16.3173 21.0068 16.4876 20.9105 16.6045 20.7539L16.6074 20.749H16.6084C16.7512 20.5627 16.8535 20.2629 16.8535 19.791C16.8535 19.312 16.7503 19.0106 16.6084 18.8252L16.6045 18.8203C16.4876 18.6637 16.3173 18.5664 16.0146 18.5664Z",
                fill: "#B7D943",
                stroke: "black"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/functions/usinas/CalculoCo2.js
function calcularCO2(kwh) {
    return kwh * 0.0385;
}
function calcularArvoresEquivalentes(kwh) {
    return kwh * 0.0385 / 60;
}

;// CONCATENATED MODULE: ./src/pages/calculadora-desconto/components/Iframe/index.jsx


































/**
 * Formulário da Calculadora
 *
 * - Campos adicionais poderão ser adicionados com prefixo "ef_": Extra Field.
 * Ex: `https://app.electy.com.br/calculadora-desconto?type=form&ef_campo1=123&ef_campo2=456`
 *
 * No exemplo temos os campos ef_campo1 e ef_campo2 adicionados e incorporados dinamicamente
 */ var Iframe = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    // Valida se deve aparecer opções para selecionar "PF"|"PJ"
    var oneOptionContractEnabled = props.wl.Calculadora.habilitar_contrato_pf && !props.wl.Calculadora.habilitar_contrato_pj ? "pf" : props.wl.Calculadora.habilitar_contrato_pj && !props.wl.Calculadora.habilitar_contrato_pf ? "pj" : false;
    var ref20 = (0,react.useState)(false), isLoading = ref20[0], setIsLoading = ref20[1];
    var ref21 = (0,react.useState)({
        valorConsumo: null,
        valorConta: null,
        dataDiscount: "",
        dataConfigOfertas: null,
        selectedConcessionaria: null,
        submitButtonChildren: "Simular economia",
        errorMessage: "",
        concessionariasMunicipio: [],
        selectedTypeButton: {
            selected: "pf",
            pf: "selected",
            pj: ""
        }
    }), formData = ref21[0], setFormData = ref21[1];
    var ref22 = (0,react.useState)({
        co2: null,
        arvores: null
    }), dadosCalculoCo2 = ref22[0], setDadosCalculoCo2 = ref22[1];
    var ref23 = (0,react.useState)(0), alturaInputCardMunicipio = ref23[0], setAlturaInputCardMunicipio = ref23[1];
    var ref24 = (0,react.useState)(0), alturaInputCardConcessionaria = ref24[0], setAlturaInputCardConcessionaria = ref24[1];
    var handleSelectTipoPessoa = function(type) {
        setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
            selectedTypeButton: {
                pf: type === "pf" ? "selected" : "",
                pj: type === "pj" ? "selected" : "",
                selected: type
            }
        }));
        configSimulacao_configSimulacao({
            setFormData: setFormData,
            formData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                selectedTypeButton: {
                    pf: type === "pf" ? "selected" : "",
                    pj: type === "pj" ? "selected" : "",
                    selected: type
                }
            }),
            concessionariaId: selectedConcessionaria === null || selectedConcessionaria === void 0 ? void 0 : selectedConcessionaria.id
        });
        setErrorMessage("");
    };
    (0,react.useEffect)(function() {
        var ref;
        if (selectedConcessionaria && (formData === null || formData === void 0 ? void 0 : formData.valorConsumo) && (formData === null || formData === void 0 ? void 0 : (ref = formData.selectedTypeButton) === null || ref === void 0 ? void 0 : ref.selected)) {
            var ref1;
            var consumoEmReais = formData === null || formData === void 0 ? void 0 : formData.valorConsumo;
            var valorKwh = (formData === null || formData === void 0 ? void 0 : (ref1 = formData.selectedTypeButton) === null || ref1 === void 0 ? void 0 : ref1.selected) === "pf" ? selectedConcessionaria === null || selectedConcessionaria === void 0 ? void 0 : selectedConcessionaria.valorKwhPf : selectedConcessionaria === null || selectedConcessionaria === void 0 ? void 0 : selectedConcessionaria.valorKwhPj;
            var consumoKwh = calcularConsumoKwh({
                consumoDinheiro: consumoEmReais,
                valorKwh: valorKwh
            });
            var co2 = calcularCO2(consumoKwh);
            var arvores = calcularArvoresEquivalentes(consumoKwh);
            setDadosCalculoCo2(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    co2: co2 * 12,
                    arvores: Math.round(arvores * 12)
                });
            });
        }
    }, [
        selectedConcessionaria,
        formData === null || formData === void 0 ? void 0 : formData.selectedTypeButton,
        formData === null || formData === void 0 ? void 0 : formData.valorConsumo
    ]);
    var ref25 = (0,react.useState)(null), selectedConcessionaria = ref25[0], setSelectedConcessionaria = ref25[1];
    // const enableSharp = props.infos.usa_sharpspring;
    var ref26 = (0,react.useState)("Simular economia"), submitButtonChildren = ref26[0], setSubmitButtonChildren = ref26[1];
    var ref27 = (0,react.useState)(""), errorMessage = ref27[0], setErrorMessage = ref27[1];
    var ref28 = (0,react.useState)([]), concessionariasMunicipio = ref28[0], setConcessionariasMunicipio = ref28[1];
    // Cada campo não preenchido é recebido nessa função: Se algum estiver na lista de bloqueados, a chamada é interrompida
    var hasInvalidInputs = function(e) {
        if (e.target.getAttribute("name") == "tipoConta") {
            setErrorMessage("Selecione o tipo da conta!");
            return true;
        }
        if (e.target.getAttribute("name") == "concessionaria") {
            setErrorMessage("Selecione a concession\xe1ria!");
            return true;
        }
        return false;
    };
    var imgSplash = (0,getUrls/* getUrls */.U)((ref = props.wl) === null || ref === void 0 ? void 0 : (ref1 = ref.splash) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.attributes) === null || ref3 === void 0 ? void 0 : ref3.url);
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var formData, formElements, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, savedLead, ref, municipioEstado, municipio, uf, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        formData = {};
                        formElements = e.target.elements;
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = formElements[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                element = _step.value;
                                if (element.name) {
                                    formData[element.name] = element.value;
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        savedLead = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        municipioEstado = (ref = formData.municipio) === null || ref === void 0 ? void 0 : ref.split(" - ");
                        municipio = municipioEstado === null || municipioEstado === void 0 ? void 0 : municipioEstado[0];
                        uf = municipioEstado === null || municipioEstado === void 0 ? void 0 : municipioEstado[1];
                        (0,lib.deleteCookie)(COOKIES_TAGS/* COOKIES_TAGS.LEAD_ID */.t.LEAD_ID);
                        return [
                            4,
                            (0,leads/* saveLead */.K3)({
                                assessor: formData.ef_assessor || formData.ef_parceiro,
                                campanha: formData.representante,
                                municipio: municipio,
                                uf: uf,
                                concessionaria: Number(formData.concessionaria),
                                tipo: formData.tipoConta,
                                valor_consumo: formData.money
                            })
                        ];
                    case 2:
                        savedLead = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log({
                            error: error
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setIsLoading(true);
                        setTimeout(function() {
                            setIsLoading(false);
                        }, 10000);
                        router_default().push("/form-dados-pessoais");
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var bgSubmitButton = submitButtonChildren != "Simular economia" || !(formData === null || formData === void 0 ? void 0 : formData.dataDiscount.status) ? {
        background: "#B6BEC9",
        color: "#fff",
        height: "42px",
        padding: "0 12px",
        minHeight: "unset",
        marginTop: "10px"
    } : {
        color: ((ref4 = props.wl) === null || ref4 === void 0 ? void 0 : ref4.cor_texto_botao) || "#fff",
        background: ((ref5 = props.wl) === null || ref5 === void 0 ? void 0 : ref5.cor_tema_botao_solido) || "#26A150" ? (ref6 = props.wl) === null || ref6 === void 0 ? void 0 : ref6.cor_tema_botao_solido : 0,
        height: "42px",
        padding: "0 12px",
        minHeight: "unset",
        marginTop: "10px"
    };
    /**
   * Configura a option de concessionária para o Lead
   */ var handleMunicipioChange = function(_selectedMunicipio) {
        var ref;
        var concessionariaOptions = [];
        _selectedMunicipio === null || _selectedMunicipio === void 0 ? void 0 : (ref = _selectedMunicipio.concessionarias) === null || ref === void 0 ? void 0 : ref.map(function(concessionaria) {
            var ref, ref1;
            concessionariaOptions.push({
                id: concessionaria.id,
                name: concessionaria.attributes.nome,
                label: concessionaria.attributes.nome,
                value: concessionaria.id,
                valorKwhPf: (ref = concessionaria.attributes) === null || ref === void 0 ? void 0 : ref.valor_kwh_pf,
                valorKwhPj: (ref1 = concessionaria.attributes) === null || ref1 === void 0 ? void 0 : ref1.valor_kwh_pj
            });
        });
        setConcessionariasMunicipio(concessionariaOptions);
        if (concessionariaOptions.length < 2) {
            var ref1;
            setSelectedConcessionaria(concessionariaOptions === null || concessionariaOptions === void 0 ? void 0 : concessionariaOptions[0]);
            findPlanosDescontos_findPlanosDescontos({
                concessionariaId: concessionariaOptions === null || concessionariaOptions === void 0 ? void 0 : (ref1 = concessionariaOptions[0]) === null || ref1 === void 0 ? void 0 : ref1.id
            }).then(function(_dataConfigOfertas) {
                var ref;
                setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                    dataConfigOfertas: _dataConfigOfertas
                }));
                configSimulacao_configSimulacao({
                    setFormData: setFormData,
                    formData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                        dataConfigOfertas: _dataConfigOfertas
                    }),
                    concessionariaId: concessionariaOptions === null || concessionariaOptions === void 0 ? void 0 : (ref = concessionariaOptions[0]) === null || ref === void 0 ? void 0 : ref.id
                });
            });
        }
    };
    var handleConcessionariaChange = function(_selectedConcessionaria) {
        setSelectedConcessionaria(_selectedConcessionaria);
        if (!_selectedConcessionaria || !_selectedConcessionaria.id) {
            // Não faz nada se não houver concessionária selecionada
            return;
        }
        findPlanosDescontos_findPlanosDescontos({
            concessionariaId: _selectedConcessionaria.id
        }).then(function(_dataConfigOfertas) {
            setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                dataConfigOfertas: _dataConfigOfertas
            }));
            configSimulacao_configSimulacao({
                setFormData: setFormData,
                formData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                    dataConfigOfertas: _dataConfigOfertas
                }),
                concessionariaId: _selectedConcessionaria.id
            });
        });
    };
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: (Iframe_styles_module_default()).iconLoading,
                src: imgSplash,
                width: 150,
                height: 150
            })
        });
    }
    var handleMenuOpen = function(alturaInputCard, estadoSelect) {
        if (estadoSelect === "open") {
            setAlturaInputCard(alturaInputCard);
        } else {
            setAlturaInputCard(0);
        }
    };
    var makeHandleMenuOpen = function(setAltura) {
        return function(altura, estado) {
            if (estado === "open") {
                setAltura(altura);
            } else {
                setAltura(0);
            }
        };
    };
    var formProps = props.isApp ? {
        onSubmit: onSubmit,
        className: (Iframe_styles_module_default()).form,
        onInvalid: hasInvalidInputs,
        method: "get"
    } : {
        className: (Iframe_styles_module_default()).form,
        onInvalid: hasInvalidInputs,
        action: "".concat("https://app.electy.com.br", "/form-dados-pessoais"),
        target: "_blank",
        method: "get"
    };
    var ref29, _owner, ref30;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formProps), {
            style: {
                padding: "0 45px"
            },
            children: [
                props.extraFields.map(function(item) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        name: (ref29 = (ref = item.key) === null || ref === void 0 ? void 0 : ref.toLowerCase()) !== null && ref29 !== void 0 ? ref29 : item.key,
                        value: item.value
                    }, "INPUT__".concat(item.key));
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "hidden",
                    name: "representante",
                    value: (_owner = props.owner) !== null && _owner !== void 0 ? _owner : props.wl.campanha_default
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "hidden",
                    name: "full",
                    value: props.full ? "1" : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: (Iframe_styles_module_default()).title,
                    style: {
                        color: (ref7 = props.wl) === null || ref7 === void 0 ? void 0 : ref7.cor_tema_primaria,
                        textAlign: "left"
                    },
                    children: "Encontre sua energia mais barata e limpa"
                }),
                !oneOptionContractEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                    className: (Iframe_styles_module_default())["select-type"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButtons, {
                        txtButton1: "Para minha casa",
                        txtButton2: "Para meu neg\xf3cio",
                        valueButton1: "pf",
                        valueButton2: "pj",
                        handleSelect: handleSelectTipoPessoa,
                        wl: props.wl
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputCard, {
                    title: "Cidade",
                    name: "municipio",
                    style: {
                        marginTop: "18px",
                        height: alturaInputCardMunicipio
                    },
                    alturaMenuOpen: alturaInputCardMunicipio,
                    wl: props.wl,
                    component: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_SelectUnstyled, {
                        id: "select",
                        name: "municipio",
                        handleMenuOpen: makeHandleMenuOpen(setAlturaInputCardMunicipio),
                        required: true,
                        handleChange: handleMunicipioChange,
                        placeholder: "Busque por cidade",
                        handleFindOptions: handleFindOptionsMunicipios,
                        wl: props.wl
                    })
                }),
                concessionariasMunicipio.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputCard, {
                    title: "Concession\xe1ria",
                    alturaMenuOpen: alturaInputCardConcessionaria,
                    wl: props.wl,
                    component: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_SelectUnstyled, {
                        id: "select-concessionaria",
                        handleMenuOpen: makeHandleMenuOpen(setAlturaInputCardConcessionaria),
                        isSearchable: false,
                        required: true,
                        placeholder: "Selecione a sua concession\xe1ria",
                        handleChange: handleConcessionariaChange,
                        options: concessionariasMunicipio,
                        wl: props.wl
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "hidden",
                    name: "concessionaria",
                    value: (selectedConcessionaria === null || selectedConcessionaria === void 0 ? void 0 : selectedConcessionaria.id) || ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputCard, {
                    title: "Quanto voc\xea gasta com luz por m\xeas?",
                    id: "money",
                    name: "money",
                    placeholder: "Digite o valor gasto",
                    value: (0,mask/* formatBRL */.o_)(formData === null || formData === void 0 ? void 0 : formData.valorConta),
                    wl: props.wl,
                    onChange: function(event) {
                        var onlyNumbers = event.target.value.replace(/\D/g, "");
                        var valorConsumo = onlyNumbers.length > 2 ? onlyNumbers.slice(0, -2) : "0";
                        setFormData(function(prev) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                valorConsumo: valorConsumo,
                                valorConta: onlyNumbers
                            });
                        });
                        configSimulacao_configSimulacao({
                            setFormData: setFormData,
                            formData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                valorConsumo: valorConsumo,
                                valorConta: onlyNumbers
                            }),
                            concessionariaId: selectedConcessionaria === null || selectedConcessionaria === void 0 ? void 0 : selectedConcessionaria.id
                        });
                    }
                }),
                errorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "msg__error__icon__alert ".concat((Iframe_styles_module_default())["msg-error"]),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/icons/notifications/alert-cicle.svg"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "error",
                            children: errorMessage
                        })
                    ]
                }) : "",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "text",
                    id: "tipoConta",
                    name: "tipoConta",
                    defaultValue: (ref30 = formData === null || formData === void 0 ? void 0 : (ref8 = formData.selectedTypeButton) === null || ref8 === void 0 ? void 0 : ref8.selected) !== null && ref30 !== void 0 ? ref30 : "",
                    required: true,
                    style: {
                        display: "none"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "hidden",
                    name: "pessoaFisica",
                    defaultValue: (formData === null || formData === void 0 ? void 0 : (ref9 = formData.selectedTypeButton) === null || ref9 === void 0 ? void 0 : ref9.selected) === "pf" ? "Sim" : "N\xe3o"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "hidden",
                    name: "pessoaJuridica",
                    defaultValue: (formData === null || formData === void 0 ? void 0 : (ref10 = formData.selectedTypeButton) === null || ref10 === void 0 ? void 0 : ref10.selected) === "pj" ? "Sim" : "N\xe3o"
                }),
                !(formData === null || formData === void 0 ? void 0 : (ref11 = formData.dataDiscount) === null || ref11 === void 0 ? void 0 : ref11.status) ? getResultMessages_getResultFailMessage(formData === null || formData === void 0 ? void 0 : (ref12 = formData.dataDiscount) === null || ref12 === void 0 ? void 0 : ref12.message) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: (Iframe_styles_module_default())["calc-economia"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconPercent, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (Iframe_styles_module_default())["calc-economia-text"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Voc\xea pode economizar at\xe9"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (Iframe_styles_module_default())["calc-economia-valor"],
                                                style: {
                                                    color: (ref13 = props.wl) === null || ref13 === void 0 ? void 0 : ref13.cor_tema_primaria
                                                },
                                                children: new Intl.NumberFormat("pt-BR", {
                                                    style: "currency",
                                                    currency: "BRL"
                                                }).format(formData === null || formData === void 0 ? void 0 : (ref14 = formData.dataDiscount) === null || ref14 === void 0 ? void 0 : ref14.valorDescontoAnual)
                                            }),
                                            " ",
                                            "/ano"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                selectedConcessionaria && dadosCalculoCo2.co2 > 0 && dadosCalculoCo2.arvores > 0 && (formData === null || formData === void 0 ? void 0 : (ref15 = formData.dataDiscount) === null || ref15 === void 0 ? void 0 : ref15.status) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: (Iframe_styles_module_default())["calc-co2"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCo2, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (Iframe_styles_module_default())["calc-co2-text"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Cerca de ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                color: (ref16 = props.wl) === null || ref16 === void 0 ? void 0 : ref16.cor_tema_primaria
                                            },
                                            children: parseInt(dadosCalculoCo2.co2)
                                        }),
                                        " kg de CO2 neutralizados."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Equivalente ao plantio de ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                color: (ref17 = props.wl) === null || ref17 === void 0 ? void 0 : ref17.cor_tema_primaria
                                            },
                                            children: Number(dadosCalculoCo2.arvores)
                                        }),
                                        " ",
                                        Number(dadosCalculoCo2.arvores) > 1 ? "\xe1rvores" : "\xe1rvore",
                                        " por ano."
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    name: !(formData === null || formData === void 0 ? void 0 : (ref18 = formData.dataDiscount) === null || ref18 === void 0 ? void 0 : ref18.status) ? "Simular economia" : "Quero saber mais",
                    isDisable: submitButtonChildren != "Simular economia" || !(formData === null || formData === void 0 ? void 0 : (ref19 = formData.dataDiscount) === null || ref19 === void 0 ? void 0 : ref19.status),
                    type: "submit",
                    className: (Iframe_styles_module_default())["submit-button"],
                    style: bgSubmitButton,
                    wl: props.wl
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Iframe_styles_module_default())["text-privacy-policy"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (Iframe_styles_module_default()).justifyText,
                            children: [
                                "Ao prosseguir voc\xea estar\xe1 aceitando os ",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitleText/* default */.Z, {
                                        "src-icon-close": "/images/icons/button/close-white.svg",
                                        content: (0,lang/* lang */.K)("usuario/index.termos-uso", ""),
                                        isApp: props.isApp
                                    })
                                }),
                                " ",
                                " e a ",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitleText/* default */.Z, {
                                        "src-icon-close": "/images/icons/button/close-white.svg",
                                        content: (0,lang/* lang */.K)("usuario/index.politica-privacidade", ""),
                                        isApp: props.isApp
                                    })
                                }),
                                " ",
                                "da Electy."
                            ]
                        })
                    })
                })
            ]
        }))
    });
};
/* harmony default export */ var components_Iframe = (Iframe);

;// CONCATENATED MODULE: ./src/pages/calculadora-desconto/components/CardForm2/index.jsx




// import NotFound from '../NotFound/index.page';
// import Success from '../Success/index.page';


// import FormFornecedor from '../FormFornecedor';
// import SemConsumoMinimo from '../SemConsumoMinimo/index.page';
// import NotFoundPlan from '../NotFoundPlan/index.page';


var CardForm = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var router = (0,next_router.useRouter)();
    var _query = router.query, app = _query.app, ownerID = _query.owner, queryType = _query.type, query // restante das propriedades
     = (0,_object_without_properties/* default */.Z)(_query, [
        "app",
        "owner",
        "type"
    ]);
    var allQueryParams = Object.keys(query).map(function(key) {
        return {
            key: key,
            value: query[key]
        };
    });
    var isApp = props.isApp;
    var extraFields = allQueryParams.filter(function(item) {
        return item.key.toLowerCase().startsWith("ef_");
    });
    // Tipos de Form Gerenciados
    var formTypes = {
        "success": "success",
        "not-found": "not-found",
        "form": "form",
        "form-fornecedor": "form-fornecedor",
        "sem-consumo-minimo": "sem-consumo-minimo",
        "not-found-plan": "not-found-plan",
        "waiting": "waiting"
    };
    var _queryType;
    var type = (_queryType = formTypes[queryType]) !== null && _queryType !== void 0 ? _queryType : "waiting";
    var imgCardLeft = (0,getUrls/* getUrls */.U)((ref = props.wl) === null || ref === void 0 ? void 0 : (ref1 = ref.card_esquerda) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.attributes) === null || ref3 === void 0 ? void 0 : ref3.url);
    var imgSplash = (0,getUrls/* getUrls */.U)((ref4 = props.wl) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.splash) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.attributes) === null || ref7 === void 0 ? void 0 : ref7.url);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!!props.full ? /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "stylesheet",
                    href: "/css/calculadora.css"
                })
            }) : "",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "".concat((styles_module_default()).container, " ").concat(props.full ? (styles_module_default()).full : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                        className: (styles_module_default())["card-left"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: imgCardLeft,
                            alt: (ref8 = props.wl) === null || ref8 === void 0 ? void 0 : ref8.empresa
                        })
                    }),
                    app == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: (styles_module_default())["card-rigth"],
                        children: [
                            // Incluir ternários para checar se é >> success / form / not-found <<
                            type == "waiting" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: (styles_module_default()).logo,
                                src: imgSplash
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FormNovaJornada, {
                                owner: ownerID,
                                full: props.full,
                                isApp: isApp,
                                wl: props.wl,
                                infos: props.infos,
                                extraFields: extraFields
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).bottomBorderExternal,
                                style: {
                                    background: (ref9 = props.wl) === null || ref9 === void 0 ? void 0 : ref9.cor_ponta_inferior_lateral_esquerda
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).bottomBorderInternal
                                })
                            }),
                            isApp && ((ref10 = props.wl) === null || ref10 === void 0 ? void 0 : ref10.empresa) === "ELECTY" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: (styles_module_default()).fio1,
                                        src: "/images/calculadora-desconto/components/Form/fio-01.svg",
                                        alt: "no-img"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: (styles_module_default()).fio2,
                                        src: "/images/calculadora-desconto/components/Form/fio-02.svg",
                                        alt: "no-img"
                                    })
                                ]
                            }) : "",
                            props.wl.Calculadora.habilitar_captura_fornecedor && queryType === "form" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).cardFornecedor,
                                style: {
                                    background: props.wl.cor_tema_4
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: function() {
                                        return router_default().push("/calculadora-desconto?type=form-fornecedor&".concat(app && "app=1"));
                                    },
                                    children: props.wl.Calculadora.texto_captura_fornecedor
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: (styles_module_default())["card-iframe"],
                        children: [
                            // Incluir ternários para checar se é >> success / form / not-found <<
                            type == "waiting" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: (styles_module_default()).logo,
                                src: imgSplash
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Iframe, {
                                owner: ownerID,
                                full: props.full,
                                isApp: isApp,
                                wl: props.wl,
                                infos: props.infos,
                                extraFields: extraFields
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).bottomBorderExternal,
                                style: {
                                    background: (ref11 = props.wl) === null || ref11 === void 0 ? void 0 : ref11.cor_ponta_inferior_lateral_esquerda
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).bottomBorderInternal
                                })
                            }),
                            isApp && ((ref12 = props.wl) === null || ref12 === void 0 ? void 0 : ref12.empresa) === "ELECTY" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: (styles_module_default()).fio1,
                                        src: "/images/calculadora-desconto/components/Form/fio-01.svg",
                                        alt: "no-img"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: (styles_module_default()).fio2,
                                        src: "/images/calculadora-desconto/components/Form/fio-02.svg",
                                        alt: "no-img"
                                    })
                                ]
                            }) : "",
                            props.wl.Calculadora.habilitar_captura_fornecedor && queryType === "form" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).cardFornecedor,
                                style: {
                                    background: props.wl.cor_tema_4
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: function() {
                                        return router_default().push("/calculadora-desconto?type=form-fornecedor&".concat(app && "app=1"));
                                    },
                                    children: props.wl.Calculadora.texto_captura_fornecedor
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CardForm2 = (CardForm);

// EXTERNAL MODULE: ./src/pages/calculadora-desconto/styles.module.css
var calculadora_desconto_styles_module = __webpack_require__(98831);
var calculadora_desconto_styles_module_default = /*#__PURE__*/__webpack_require__.n(calculadora_desconto_styles_module);
;// CONCATENATED MODULE: ./src/pages/calculadora-desconto/index.page.jsx




var __N_SSG = true;
function CalculadoraDesconto(props) {
    var router = (0,next_router.useRouter)();
    var version = router.query.v;
    var isApp = router.query.app == 1;
    var _defaultOwner;
    // const [textArr, setTextArr] = useState([]);
    // useEffect(() => {
    //   setTextArr(marked.parse(props.infos.texto_test_2).split('\\n') ?? []);
    // });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((calculadora_desconto_styles_module_default()).container, " ").concat(isApp ? (calculadora_desconto_styles_module_default()).full : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardForm2, {
            full: isApp,
            wl: props.wl,
            infos: props.infos,
            isApp: isApp,
            defaultOwner: (_defaultOwner = props.defaultOwner) !== null && _defaultOwner !== void 0 ? _defaultOwner : "-"
        })
    });
}


/***/ }),

/***/ 96590:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__o56sT","arrowRight":"styles_arrowRight__rAug5"};

/***/ }),

/***/ 52502:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spanButton":"styles_spanButton__V_CxO","button":"styles_button__jWSpa","img":"styles_img___0_Lb"};

/***/ }),

/***/ 53522:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input-card":"styles_input-card__VTwaq","moneyInputWrapper":"styles_moneyInputWrapper__bZC1Q","cifrao":"styles_cifrao__icabP","moneyInput":"styles_moneyInput__rgDge"};

/***/ }),

/***/ 14334:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__egtMf","control":"styles_control__QGEcK"};

/***/ }),

/***/ 59938:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__wrQ_d","control":"styles_control__m8E_p","custom-scroll__menu-list":"styles_custom-scroll__menu-list__bCqD_"};

/***/ }),

/***/ 8751:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"toggle-buttons":"styles_toggle-buttons__1d3Dj","btn":"styles_btn___763_","active":"styles_active__R_6Ym"};

/***/ }),

/***/ 30974:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__OBX21","card-left":"styles_card-left__Y4qLR","full":"styles_full__d10pc","card-rigth":"styles_card-rigth__EU_v6","bottomBorderExternal":"styles_bottomBorderExternal__JKmA7","bottomBorderInternal":"styles_bottomBorderInternal__19VVg","fio1":"styles_fio1__tsx6x","fio2":"styles_fio2__WmV9y","card-iframe":"styles_card-iframe__spc8S","borderRadiusBottom":"styles_borderRadiusBottom__4ki8l","borderRadiusTop":"styles_borderRadiusTop__4P5NJ","cardFornecedor":"styles_cardFornecedor__3_0Xj"};

/***/ }),

/***/ 93283:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__URBXG","h5":"styles_h5__uC_m3","iconLoading":"styles_iconLoading__JSwSf","title-select-type":"styles_title-select-type__vEPsF","select-type":"styles_select-type__S8BET","button":"styles_button__LqYbg","msg-error":"styles_msg-error__vL0ns","text-privacy-policy":"styles_text-privacy-policy__SxNEV","name-lastname":"styles_name-lastname__mD2SS","loadingFinddiscounts":"styles_loadingFinddiscounts__8LdUw","msgDiscount":"styles_msgDiscount__LiR9W","msgDiscountError":"styles_msgDiscountError__Rnj3a"};

/***/ }),

/***/ 77212:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2xN5L","form":"styles_form__QUu_B","h5":"styles_h5__dpnez","iconLoading":"styles_iconLoading__WwsiO","title-select-type":"styles_title-select-type__w8OY0","select-type":"styles_select-type__nIz9C","button":"styles_button__1YZ_1","msg-error":"styles_msg-error__56TWt","text-privacy-policy":"styles_text-privacy-policy__ebhwg","name-lastname":"styles_name-lastname__BSFlX","loadingFinddiscounts":"styles_loadingFinddiscounts__0GDTE","msgDiscount":"styles_msgDiscount__53hrE","msgDiscountError":"styles_msgDiscountError__KwgNN","button-submit":"styles_button-submit__CpqQ_","calc-economia":"styles_calc-economia__vGJ9T","calc-economia-text":"styles_calc-economia-text__VIDUH","calc-economia-valor":"styles_calc-economia-valor__7dEB_","calc-co2":"styles_calc-co2__R3QeA","calc-co2-text":"styles_calc-co2-text__w_AM2"};

/***/ }),

/***/ 59760:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slider":"styles_slider__fSfQi","text-value":"styles_text-value__Q5_bv"};

/***/ }),

/***/ 98831:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__LrQg3","full":"styles_full__tV6O9"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8764,9669,5630,506,1394,8533,9774,2888,179], function() { return __webpack_exec__(51231); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);